var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC23(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "297.19 76.59 312.71 125.67 301.47 125.67 296.52 108.75 297.19 76.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.83,
    y: 125.63,
    width: 231.69,
    height: 13.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.12,
    y: 136.45,
    width: 11.21,
    height: 21.26,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.79,
    y: 136.45,
    width: 11.21,
    height: 21.26,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.7,61.43s-10.39,7.92-.43,18.38a.87.87,0,0,0,.66.28l90.85-.53s7.75-8.7,1.32-18.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.7,69.7c0,.1-11.31.18-25.27.18s-25.26-.08-25.26-.18,11.31-.19,25.26-.19S175.7,69.59,175.7,69.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.57,73c0,.1-5.32.18-11.88.18s-11.88-.08-11.88-.18,5.32-.18,11.88-.18S161.57,72.88,161.57,73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,79.27c-.06,0,.2-1,.48-2.72a39.4,39.4,0,0,0,.52-6.63,37.66,37.66,0,0,0-.65-6.62c-.31-1.68-.59-2.7-.53-2.72a3.31,3.31,0,0,1,.26.7,19.52,19.52,0,0,1,.53,2,32.13,32.13,0,0,1,.12,13.34c-.17.85-.34,1.52-.48,2A3.13,3.13,0,0,1,185,79.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.77,60.72a3.38,3.38,0,0,1,.4.66,6.92,6.92,0,0,1,.41.82,11.39,11.39,0,0,1,.46,1.11,19.43,19.43,0,0,1,.86,3,21.43,21.43,0,0,1,.4,3.82A22.68,22.68,0,0,1,194,74a20.36,20.36,0,0,1-.82,3c-.14.43-.31.79-.45,1.12a7.15,7.15,0,0,1-.39.82,3.45,3.45,0,0,1-.39.67c-.06,0,.44-1,1-2.69a21.31,21.31,0,0,0,.73-3,23.33,23.33,0,0,0,.3-3.77,23.88,23.88,0,0,0-.36-3.76,21.9,21.9,0,0,0-.78-3C192.23,61.72,191.7,60.75,191.77,60.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,79.39a2.62,2.62,0,0,1-.42-.6,6.86,6.86,0,0,1-.43-.76,8.75,8.75,0,0,1-.48-1,15.65,15.65,0,0,1-.89-2.86,18.19,18.19,0,0,1-.35-3.66,17.78,17.78,0,0,1,.45-3.65,15.65,15.65,0,0,1,1-2.84c.16-.4.36-.73.51-1a6.42,6.42,0,0,1,.45-.75,2.93,2.93,0,0,1,.44-.6c.06,0-.52.92-1.16,2.48a18.13,18.13,0,0,0-.87,2.81,18.82,18.82,0,0,0-.41,3.58,20.09,20.09,0,0,0,.31,3.59,17.23,17.23,0,0,0,.8,2.84C118.54,78.46,119.1,79.36,119,79.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.23,81.61a3.61,3.61,0,0,1-.47-.69,7.7,7.7,0,0,1-.47-.85,11.87,11.87,0,0,1-.55-1.17,18.37,18.37,0,0,1-1-3.21,22.19,22.19,0,0,1-.51-4.1,21.37,21.37,0,0,1,.33-4.12,20,20,0,0,1,.89-3.25c.15-.45.35-.84.5-1.19a8,8,0,0,1,.44-.88,3.68,3.68,0,0,1,.43-.7c.07,0-.51,1.06-1.12,2.86a21.52,21.52,0,0,0-.81,3.22,21.18,21.18,0,0,0,.18,8.09,21,21,0,0,0,1,3.18C108.67,80.57,109.29,81.57,109.23,81.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.44,107.23v17.39H158.8V107.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8,116.09c0,.15,0,.3,0,.46a10,10,0,0,0,10,9.32H194v-1.25H170.23a8.69,8.69,0,0,1-8.69-8.7h0a8.69,8.69,0,0,1,8.69-8.69H194v-1.85l-100.22.34A10,10,0,0,0,83.8,116.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.44,116.16c0,.1-6.91.18-15.44.18s-15.45-.08-15.45-.18S168.46,116,177,116,192.44,116.06,192.44,116.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,120.07c0,.11-6.55.19-14.62.19s-14.62-.08-14.62-.19,6.55-.18,14.62-.18S192,120,192,120.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.44,123.66c0,.1-5.88.18-13.14.18s-13.14-.08-13.14-.18,5.88-.19,13.14-.19S192.44,123.56,192.44,123.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.44,112.64c0,.1-6.77.18-15.13.18s-15.13-.08-15.13-.18,6.77-.19,15.13-.19S192.44,112.54,192.44,112.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,109.12c0,.1-6,.18-13.47.18s-13.47-.08-13.47-.18,6-.19,13.47-.19S192,109,192,109.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.94,106a21.57,21.57,0,0,0-2.13,2.54A12.86,12.86,0,0,0,94,123.44a21.22,21.22,0,0,0,2.19,2.48,3.46,3.46,0,0,1-.72-.53,11.66,11.66,0,0,1-1.68-1.79,12.68,12.68,0,0,1-.18-15.2,12.07,12.07,0,0,1,1.64-1.84A3.68,3.68,0,0,1,95.94,106Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.55,105.64a21.9,21.9,0,0,0-2.13,2.53,12.85,12.85,0,0,0,.18,14.9,21.79,21.79,0,0,0,2.18,2.48,3.46,3.46,0,0,1-.72-.53,11.69,11.69,0,0,1-1.67-1.79,12.68,12.68,0,0,1-.18-15.2,11.58,11.58,0,0,1,1.63-1.84A3.68,3.68,0,0,1,92.55,105.64Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.62,106a22.83,22.83,0,0,0-2.13,2.54,12.88,12.88,0,0,0,.18,14.89,20.15,20.15,0,0,0,2.19,2.48,3.46,3.46,0,0,1-.72-.53,11.19,11.19,0,0,1-1.68-1.79,12.68,12.68,0,0,1-.18-15.2,12.1,12.1,0,0,1,1.63-1.84A4.59,4.59,0,0,1,160.62,106Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.24,105.64a21.9,21.9,0,0,0-2.13,2.53,12.87,12.87,0,0,0,.17,14.9,22.36,22.36,0,0,0,2.19,2.48,3.46,3.46,0,0,1-.72-.53,11.66,11.66,0,0,1-1.68-1.79,12.68,12.68,0,0,1-.18-15.2,12.07,12.07,0,0,1,1.64-1.84A3.68,3.68,0,0,1,157.24,105.64Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.34,118.53c0-2.36-.07-4.71-.1-7.07a5,5,0,0,0-.25-1.82,1.7,1.7,0,0,0-1.34-1.13c-.88-.39-2.26.34-2.88,1.36a6.71,6.71,0,0,0-.7,3.47,52,52,0,0,0,.27,5.58,6.6,6.6,0,0,0,.66,2.56,2.37,2.37,0,0,0,2.16,1.29,2.41,2.41,0,0,0,1.89-1.64A7.09,7.09,0,0,0,107.34,118.53Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.25,116.5c0,.1-7.24.18-16.18.18s-16.17-.08-16.17-.18,7.24-.19,16.17-.19S146.25,116.4,146.25,116.5Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.63 105.32 100.44 88.84 109.41 88.84 109.72 105.32 100.63 105.32",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.88,91.77a23.63,23.63,0,0,1-4.17.19,23.63,23.63,0,0,1-4.17-.19,24.27,24.27,0,0,1,4.17-.18A24.27,24.27,0,0,1,108.88,91.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.88,94.32a24.27,24.27,0,0,1-4.17.18,24.27,24.27,0,0,1-4.17-.18,22.53,22.53,0,0,1,4.17-.19A22.53,22.53,0,0,1,108.88,94.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.88,96.86a24.27,24.27,0,0,1-4.17.18,24.27,24.27,0,0,1-4.17-.18,24.27,24.27,0,0,1,4.17-.18A24.27,24.27,0,0,1,108.88,96.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.88,99.4a23.63,23.63,0,0,1-4.17.19,23.63,23.63,0,0,1-4.17-.19,24.27,24.27,0,0,1,4.17-.18A24.27,24.27,0,0,1,108.88,99.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.88,102a24.27,24.27,0,0,1-4.17.18,24.27,24.27,0,0,1-4.17-.18,22.53,22.53,0,0,1,4.17-.19A22.53,22.53,0,0,1,108.88,102Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,88.4h99.42a46.59,46.59,0,0,1,0,17.82h-99V105h6a2.84,2.84,0,0,0,2.85-2.85V92.29a2.85,2.85,0,0,0-2.85-2.86H100Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.47,97.32h1.66a.41.41,0,0,1,.18.05.33.33,0,0,1,.17.31.31.31,0,0,1,0,.1c0,.14-.07.29-.11.43a4.76,4.76,0,0,1-1,1.88,2,2,0,0,1-1.41.73l-.2,0a1.59,1.59,0,0,1-1.13-.81,3.73,3.73,0,0,1-.5-2,5.41,5.41,0,0,1,.2-1.42,4.82,4.82,0,0,1,1-1.93,2,2,0,0,1,1.5-.79,1.52,1.52,0,0,1,.63.14,2,2,0,0,1,1,1.21.35.35,0,0,1,0,.17.39.39,0,0,1,0,.18.36.36,0,0,1-.31.18l-.11,0a.34.34,0,0,1-.23-.22l0,0a1.79,1.79,0,0,0-.2-.39.93.93,0,0,0-.79-.47.89.89,0,0,0-.55.2,3,3,0,0,0-.91,1.3,4.9,4.9,0,0,0-.39,1.87,3.35,3.35,0,0,0,.29,1.47,1,1,0,0,0,.86.65,1.14,1.14,0,0,0,.8-.48,4.46,4.46,0,0,0,.86-1.54c-.77,0-1.17,0-1.19,0-.26,0-.4-.17-.4-.4a.53.53,0,0,1,0-.12A.39.39,0,0,1,123.47,97.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.11,94.08l0,.12q.1.38,1.17,6.16a.28.28,0,0,1,0,.09.43.43,0,0,1,0,.19.34.34,0,0,1-.3.18h-.06a.31.31,0,0,1-.27-.24l-.4-2h-2l-1,2.06,0,.06a.41.41,0,0,1-.31.18.36.36,0,0,1-.2-.06.35.35,0,0,1-.16-.3.52.52,0,0,1,0-.11c.06-.14.17-.36.31-.67Q128,95,128.44,94.15a.41.41,0,0,1,.35-.25A.39.39,0,0,1,129.11,94.08Zm-.44,1.38-1.11,2.32h1.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.66,100.82h-3a.33.33,0,0,1-.19-.06.54.54,0,0,1-.17-.38h0c0-.12.28-2.17.83-6.13a.68.68,0,0,1,0-.14.32.32,0,0,1,.32-.21.29.29,0,0,1,.16,0,.32.32,0,0,1,.19.31c0,.27-.09.83-.2,1.68-.35,2.62-.52,4-.54,4.15h2.55a.41.41,0,0,1,.19,0,.33.33,0,0,1,.23.33.5.5,0,0,1,0,.12A.44.44,0,0,1,134.66,100.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.76,94.08a.56.56,0,0,0,0,.12q.1.38,1.17,6.16a.29.29,0,0,1,0,.09.45.45,0,0,1-.05.19.33.33,0,0,1-.3.18h-.06a.31.31,0,0,1-.27-.24l-.4-2h-2l-1,2.06,0,.06a.41.41,0,0,1-.31.18.33.33,0,0,1-.19-.06.34.34,0,0,1-.17-.3.26.26,0,0,1,0-.11l.3-.67q2.14-4.68,2.56-5.53a.41.41,0,0,1,.35-.25A.43.43,0,0,1,138.76,94.08Zm-.45,1.38-1.1,2.32h1.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.53,97.62q.34,1,.54,1.5c.31.85.46,1.3.46,1.35a.27.27,0,0,1-.05.18.34.34,0,0,1-.3.17.35.35,0,0,1-.3-.24.57.57,0,0,0-.06-.15c-.16-.38-.43-1.08-.8-2.12l-1.69,2.32a.46.46,0,0,1-.32.19.37.37,0,0,1-.18,0,.32.32,0,0,1-.17-.3v-.08a1,1,0,0,1,.18-.29c.57-.73,1.2-1.6,1.88-2.62l-.2-.57c-.64-1.7-1-2.59-1-2.64a.41.41,0,0,1,.05-.19.3.3,0,0,1,.28-.18.38.38,0,0,1,.34.2l1,2.7,2-2.72a.39.39,0,0,1,.32-.17.29.29,0,0,1,.16,0,.32.32,0,0,1,.17.32.5.5,0,0,1,0,.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.94,93.93a.33.33,0,0,1,.17,0,.35.35,0,0,1,.19.3q-.74,5.82-.81,6.28a3.86,3.86,0,0,1-.64,1.64,2.3,2.3,0,0,1-2.95.72,2.12,2.12,0,0,1-1.06-.92.58.58,0,0,1,0-.18.41.41,0,0,1,0-.18.34.34,0,0,1,.31-.17.33.33,0,0,1,.27.14,2,2,0,0,0,1.54.88,1.56,1.56,0,0,0,1.19-.61,3.43,3.43,0,0,0,.66-1.88,2.18,2.18,0,0,1-.44.47,1.85,1.85,0,0,1-1.08.35h-.2A1.62,1.62,0,0,1,147,100a3.73,3.73,0,0,1-.5-2c0-.36,0-.74,0-1.12.06-.61.19-1.47.41-2.59a.22.22,0,0,1,0-.1.33.33,0,0,1,.32-.24.26.26,0,0,1,.17,0,.3.3,0,0,1,.18.28,12.4,12.4,0,0,1-.16,1.37,18.38,18.38,0,0,0-.24,2.09,4.15,4.15,0,0,0,.27,1.62c.2.49.5.73.89.73h.12a1.61,1.61,0,0,0,.89-.72,4.42,4.42,0,0,0,.74-1.65l.46-3.42a.42.42,0,0,1,0-.15A.33.33,0,0,1,150.94,93.93Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.65,106.45c-.1,0-.18-4.09-.18-9.14s.08-9.14.18-9.14.18,4.09.18,9.14S195.75,106.45,195.65,106.45Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.29,106.45c-.1,0-.18-4.09-.18-9.14s.08-9.14.18-9.14.19,4.09.19,9.14S114.4,106.45,114.29,106.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.39,106.45c-.1,0-.18-4.09-.18-9.14s.08-9.14.18-9.14.19,4.09.19,9.14S197.5,106.45,197.39,106.45Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.66,106.45c-.1,0-.18-4.09-.18-9.14s.08-9.14.18-9.14.19,4.09.19,9.14S112.77,106.45,112.66,106.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54,91.18v0L182,99.63l.09.07-.12,0-1.4.37-8.87,2.33h0l-8-3.41-2.28-1-.6-.26-.15-.07s0,0,0,0l0,0,.16.06.61.25,2.28.95,8.06,3.37h0l8.86-2.33,1.4-.37,0,.1-10.49-8.5h0v0",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.09 98.31 181.66 98.85 182.43 98.68 182.09 99.39 182.49 100.07 181.71 99.97 181.18 100.56 181.04 99.79 180.32 99.47 181.01 99.09 181.09 98.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.01 101.65 171.4 101.98 171.89 101.84 171.7 102.31 171.98 102.73 171.47 102.7 171.16 103.1 171.03 102.61 170.56 102.43 170.99 102.16 171.01 101.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.87 97.08 160.5 97.12 160.88 96.63 161.04 97.23 161.63 97.45 161.1 97.78 161.07 98.41 160.59 98.01 159.99 98.18 160.22 97.6 159.87 97.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.8 91.32 186.42 91.36 186.81 90.86 186.96 91.47 187.55 91.68 187.02 92.02 187 92.64 186.52 92.25 185.91 92.42 186.15 91.83 185.8 91.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.03 90.91 171.43 90.93 171.68 90.62 171.78 91 172.15 91.14 171.82 91.36 171.8 91.75 171.49 91.5 171.11 91.61 171.26 91.24 171.03 90.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.67,91.75s-3.4-.07-7.59-.25-7.59-.36-7.58-.4,3.4.08,7.59.26S186.67,91.71,186.67,91.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.49,88.25H89.66c-1.32-3-1.65-5.84,0-8.39H190.49A9.73,9.73,0,0,1,190.49,88.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.54,
    y: 82.25,
    width: 54.63,
    height: 3.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.53,88.3a3.22,3.22,0,0,1-.8-1,7.39,7.39,0,0,1-.53-6.07,2.84,2.84,0,0,1,.61-1.14,11.46,11.46,0,0,1-.36,1.21A8.52,8.52,0,0,0,93,87.16,9.7,9.7,0,0,1,93.53,88.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.71,88.3a3.22,3.22,0,0,1-.8-1,7.39,7.39,0,0,1-.53-6.07A2.84,2.84,0,0,1,95,80.07a11.46,11.46,0,0,1-.36,1.21,8.65,8.65,0,0,0-.27,3,8.9,8.9,0,0,0,.78,2.89A8.06,8.06,0,0,1,95.71,88.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.41,88.1a17.34,17.34,0,0,0,.71-4.1,17.27,17.27,0,0,0-.66-4.12,7.46,7.46,0,0,1,1,4.12A7.27,7.27,0,0,1,186.41,88.1Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.53,88.08c-.11,0,.32-1.8.31-4s-.43-4-.32-4a9.6,9.6,0,0,1,.68,4A9.69,9.69,0,0,1,184.53,88.08Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.99 36.25 297.19 36.25 297.19 126.54 228.47 126.54 227.99 36.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.97,
    y: 36.69,
    width: 68.79,
    height: 89.37,
    transform: "translate(514.73 162.76) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.11,36.35v90.06H222.63V36.35Zm-.69,89.37V37H223.31v88.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.14,
    y: 46.39,
    width: 52.67,
    height: 70.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,46.37s0,.12,0,.34,0,.56,0,1c0,.87,0,2.15,0,3.81,0,3.33,0,8.2,0,14.36,0,12.31,0,29.79.08,50.52l-.16-.16,52.66,0h0l-.18.18c0-26.08,0-50.25,0-70l.15.15-38.25-.08-10.65,0H231l-1,0,.94,0h2.78l10.61,0,38.34-.07h.14v.15c0,19.77,0,43.94,0,70v.17h-53v-.16c0-20.77.06-38.29.08-50.63,0-6.14,0-11,0-14.32,0-1.65,0-2.91,0-3.78,0-.42,0-.74,0-1S230,46.37,230,46.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.81,126.07a8.81,8.81,0,0,1,.93-1.52c.61-.9,1.47-2.14,2.47-3.49s1.93-2.53,2.63-3.37a7.85,7.85,0,0,1,1.2-1.3,9.25,9.25,0,0,1-1,1.46l-2.55,3.43-2.55,3.42A9.48,9.48,0,0,1,222.81,126.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,36.69a49,49,0,0,1,3.68,4.74A50.42,50.42,0,0,1,230,46.37a49.57,49.57,0,0,1-3.68-4.73A51.19,51.19,0,0,1,223,36.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 291.76,
    y1: 36.69,
    x2: 282.71,
    y2: 46.73,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.71,46.73a63,63,0,0,1,4.39-5.14c2.51-2.77,4.59-5,4.66-4.9a60.65,60.65,0,0,1-4.39,5.14A66.78,66.78,0,0,1,282.71,46.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.76,126.07a62,62,0,0,1-4.45-4.68,54.73,54.73,0,0,1-4.19-4.91,62,62,0,0,1,4.45,4.68A54.73,54.73,0,0,1,291.76,126.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.56,116.38s5.67-17.55,9-19.42a32.28,32.28,0,0,1,14.79-4c7.8-.07,11.52.51,16.09,3.65,5.28,3.64,8.86,19.6,8.86,19.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.27,64.1c-4.84.22-6,6.72-5.7,10.43.16,1.76.7,3.67-.19,5.2-.63,1.08-1.87,1.73-2.39,2.87-.64,1.38,0,3,.43,4.42s.66,3.28-.49,4.27a41.92,41.92,0,0,0,8.36,1.57A14.11,14.11,0,0,0,256.48,91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.81,77.09c-3.19-7.32,1.15-11.8,4-13.41a11.9,11.9,0,0,1,5.62-1.22,20.57,20.57,0,0,1,5.7.51A10.21,10.21,0,0,1,265,65.73c2.32,2.48,2.86,6.15,2.65,9.54a26.46,26.46,0,0,1-3.34,11.41,2.8,2.8,0,0,1-1,1.16,1,1,0,0,1-1.37-.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.6,102.21c3.29.22,6.16-2.6,6.51-7.67l1.75-25.75-.12,1.78a2.07,2.07,0,0,0-1.86-2.09l-10.2-1a6.22,6.22,0,0,0-6.84,5.81A62.66,62.66,0,0,0,245,84.88c1,5.88,5.46,6.61,5.46,6.61l-.35,4.27a6,6,0,0,0,5.54,6.45Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.8,76.56a.76.76,0,0,0,.73.76.73.73,0,0,0,.78-.69.77.77,0,0,0-.73-.76A.73.73,0,0,0,246.8,76.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.89,75.73c.09.1.66-.33,1.48-.33s1.4.41,1.49.31-.05-.22-.31-.41a2.08,2.08,0,0,0-1.2-.37,2,2,0,0,0-1.17.39C245.93,75.51,245.84,75.69,245.89,75.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.6,76.56a.76.76,0,0,0,.73.76.72.72,0,0,0,.77-.69.76.76,0,0,0-.73-.76A.72.72,0,0,0,254.6,76.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.87,75.86c.09.1.66-.33,1.48-.33s1.4.41,1.49.31,0-.23-.31-.41a2.08,2.08,0,0,0-1.2-.37,2,2,0,0,0-1.17.38C253.91,75.64,253.82,75.81,253.87,75.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.94,81.89a4.78,4.78,0,0,0-1.32-.24c-.2,0-.4-.06-.44-.2a1.08,1.08,0,0,1,.14-.62c.19-.5.4-1,.61-1.58a26.89,26.89,0,0,0,1.36-4.13,27.45,27.45,0,0,0-1.69,4L249,80.72a1.19,1.19,0,0,0-.11.82.56.56,0,0,0,.34.3,1.72,1.72,0,0,0,.36,0A5.82,5.82,0,0,0,250.94,81.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41,91.49a14.9,14.9,0,0,0,7.87-2.12s-2.1,4.07-8,3.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.29,83.84a1.46,1.46,0,0,1,1.31-.55,1.33,1.33,0,0,1,.92.5.83.83,0,0,1,.07,1,1,1,0,0,1-1.06.28,3.16,3.16,0,0,1-1-.62.75.75,0,0,1-.23-.24.25.25,0,0,1,0-.3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.33,82.44c-.13,0-.13.87-.88,1.5s-1.69.54-1.7.66.21.17.61.18a2.21,2.21,0,0,0,1.41-.5,1.92,1.92,0,0,0,.69-1.26C253.49,82.65,253.39,82.44,253.33,82.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.5,74.44c.08.22.89.11,1.84.22s1.73.37,1.85.17-.08-.3-.39-.51a3.18,3.18,0,0,0-1.37-.48A3.12,3.12,0,0,0,254,74C253.64,74.16,253.47,74.33,253.5,74.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.18,73.38c.15.18.7,0,1.38,0s1.24.12,1.37-.07,0-.28-.28-.46a2,2,0,0,0-2.22.08C246.2,73.1,246.12,73.29,246.18,73.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.43,63.33c5.7-3.2,11.82-1,16.43,3.67a11.39,11.39,0,0,0,3.26,2.79c1.43.61,3.33.51,4.19,1.81,1,1.53-.35,3.68.38,5.35s2.77,2,3.56,3.46c.61,1.16.23,2.57-.06,3.85s-.4,2.83.56,3.72l-12.26,4.66a3.18,3.18,0,0,1-1.72.19c-1.74-.35-1.87-2-1.71-3.3a5.4,5.4,0,0,0-.08-3c-.5-1.08-1.76-1.66-2.21-2.76-.79-1.94,1.4-4,1.14-6a3.93,3.93,0,0,0-2.5-2.83,39.36,39.36,0,0,0-3.79-1.1,11.31,11.31,0,0,1-6.5-6.52,3.17,3.17,0,0,1,1.31-4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "653.75 32.69 653.75 156.46 493.88 156.46 488.12 33.55 653.75 32.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.53,
    y: 15,
    width: 123.06,
    height: 159.87,
    transform: "translate(473.12 662.99) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.6,157.07H487.51V32.8H648.6Zm-159.87-1.22H647.38V34H488.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.44,
    y: 46.05,
    width: 125.24,
    height: 94.21,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.68,46.05l-.61,0-1.76,0-6.83,0-25.68.08-90.36.14.28-.29c0,28.26,0,60.34,0,94.2v0l-.31-.32,125.23.05-.26.27c.06-28.48.11-52,.14-68.41,0-8.22.05-14.65.07-19,0-2.19,0-3.87,0-5s0-1.74,0-1.74,0,.57,0,1.68,0,2.81,0,5c0,4.39,0,10.8.07,19,0,16.46.08,40,.14,68.58v.26h-.27l-125.23.05h-.32v-.33c0-33.86,0-65.94,0-94.2v-.28h.29l90.54.14,25.63.08,6.76,0,1.73,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.12,33.12a16.23,16.23,0,0,1,2.71,1.66c1.62,1.1,3.84,2.64,6.24,4.42s4.53,3.45,6,4.71a15.78,15.78,0,0,1,2.34,2.14,16.23,16.23,0,0,1-2.62-1.79l-6.13-4.55-6.13-4.56A16.36,16.36,0,0,1,488.12,33.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648,33.41c.1.14-3.69,3.09-8.47,6.58s-8.74,6.21-8.85,6.06,3.69-3.08,8.48-6.58S647.89,33.27,648,33.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 647.99,
    y1: 156.46,
    x2: 630.04,
    y2: 140.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630,140.27c.12-.13,4.23,3.39,9.19,7.86s8.88,8.2,8.76,8.33-4.23-3.39-9.19-7.86S629.92,140.4,630,140.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.12,156.46c-.12-.13,3.63-3.7,8.36-8s8.66-7.63,8.78-7.5-3.62,3.7-8.36,8S488.24,156.59,488.12,156.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.27,92.3a15.12,15.12,0,1,1-11.65-17.93A15.12,15.12,0,0,1,598.27,92.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.57,103.52c-.16-.08.49-1.63,1.32-4.18a25.33,25.33,0,0,0,1.38-10.16,14.1,14.1,0,0,0-4.42-8.92c-2-1.75-3.66-2.12-3.59-2.32s1.84,0,4.12,1.68a13.88,13.88,0,0,1,5.06,9.43,22.26,22.26,0,0,1-1.77,10.57C579.62,102.15,578.7,103.58,578.57,103.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.08,87.33c-.07.35-4.08-1.1-8.79.3s-7.31,4.76-7.55,4.5c-.12-.08.34-1,1.53-2.26a13.41,13.41,0,0,1,12.3-3.61C597.23,86.64,598.14,87.2,598.08,87.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.26,86.56c-.2,0-.11-1.06-.65-2.54a6.79,6.79,0,0,0-9.82-3.83c-1.4.73-2,1.55-2.2,1.43s.31-1.12,1.77-2.14a7.11,7.11,0,0,1,11,4.3C591.79,85.53,591.38,86.6,591.26,86.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.44,88.16c-.34-.07-.1-2.15-.7-4.56s-1.71-4.16-1.45-4.38,2,1.37,2.6,4.1S586.73,88.26,586.44,88.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.3,83.42c0,.35-1.32.42-2.56,1.08s-2.31,1.55-2.55,1.29.42-1.45,2-2.34S586.37,83.14,586.3,83.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.12,90.51A11.47,11.47,0,1,1,546,91.91,11.47,11.47,0,0,1,562.12,90.51Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.6,107.69c-.11.09-.92-.9-2.33-2.37a19.21,19.21,0,0,0-6.31-4.55,10.79,10.79,0,0,0-7.55-.22,18.63,18.63,0,0,0-2.83,1.58c-.08,0,.63-1.25,2.59-2.16a10.47,10.47,0,0,1,8.12,0,16.87,16.87,0,0,1,6.45,5A9.48,9.48,0,0,1,562.6,107.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.72,88.86c.21.17-2.19,2.33-2.93,6s.57,6.59.32,6.66-.58-.6-1-1.83a10.14,10.14,0,0,1,2-9.52C558,89.18,558.65,88.77,558.72,88.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.77,93.15c-.08.13-.75-.3-1.93-.47a5.16,5.16,0,0,0-6.07,5.21c0,1.2.31,1.92.18,2s-.65-.61-.81-2A5.41,5.41,0,0,1,554,92.06C555.27,92.43,555.84,93.08,555.77,93.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.12,97c-.17.2-1.47-.7-3.3-1.16s-3.4-.34-3.45-.59,1.62-.82,3.68-.28S555.29,96.79,555.12,97Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.9,95.35c.23.14-.19,1-.19,2.1s.21,2.1-.05,2.17-.82-.8-.84-2.18S551.74,95.2,551.9,95.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.61,86.56c-4.06-2.64-6.55-7.35-8.16-11.91a22.38,22.38,0,0,1-.18-14.26A18.61,18.61,0,0,1,564,70.81c1.69,4.59.7,11.34-1.41,15.75",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.89,67.88a159,159,0,0,1,4.35,18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.24,85.89a13.14,13.14,0,0,1-.72-2.62c-.45-1.88-.95-4-1.5-6.37s-1.12-4.49-1.58-6.36a13.32,13.32,0,0,1-.55-2.66,10.53,10.53,0,0,1,1,2.54c.52,1.6,1.16,3.83,1.77,6.33s1.05,4.77,1.32,6.43A10.38,10.38,0,0,1,562.24,85.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.87,107.14c4.73-1,9.82.57,14.19,2.65a22.45,22.45,0,0,1,10.21,9.95,18.54,18.54,0,0,1-14.27-.47c-4.43-2-8.51-7.52-10.13-12.13",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.42,117a161.51,161.51,0,0,1-15.82-9.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.6,107.35a13.23,13.23,0,0,1,2.37,1.34l5.56,3.45,5.61,3.38a12.18,12.18,0,0,1,2.28,1.5,11.28,11.28,0,0,1-2.5-1.11c-1.49-.76-3.53-1.89-5.72-3.23s-4.12-2.63-5.48-3.61A10.47,10.47,0,0,1,573.6,107.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.28,109.39c.87,2.76.24,5.88-.75,8.6a13.36,13.36,0,0,1-5.32,6.65,11.08,11.08,0,0,1-.55-8.51c1-2.76,4-5.5,6.62-6.74",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.37,119.81a99.43,99.43,0,0,1,4.82-10",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.19,109.84c.16.09-.94,2.31-2.26,5s-2.39,5-2.56,4.92.64-2.43,2-5.19S568.05,109.75,568.19,109.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.02,
    y: 183.61,
    width: 93.14,
    height: 97.09,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 612.71,
    y: 183.61,
    width: 93.14,
    height: 97.09,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.88,280.73h-93.2V183.59h93.2Zm-93.14-.06h93.08v-97H612.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.23,
    y: 196.67,
    width: 68.1,
    height: 70.98,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.23,268.12a10.89,10.89,0,0,1-1.68,2c-1.09,1.14-2.62,2.7-4.33,4.39s-3.29,3.19-4.45,4.25a10.55,10.55,0,0,1-2,1.64,11.73,11.73,0,0,1,1.68-1.94c1.08-1.15,2.62-2.71,4.33-4.4s3.3-3.2,4.46-4.27A11.3,11.3,0,0,1,625.23,268.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.33,268a11.52,11.52,0,0,1,1.95,1.68c1.15,1.09,2.7,2.62,4.39,4.33s3.19,3.29,4.26,4.45a11.74,11.74,0,0,1,1.64,2,10.58,10.58,0,0,1-2-1.67c-1.15-1.08-2.7-2.62-4.4-4.33s-3.19-3.3-4.26-4.46A10.22,10.22,0,0,1,693.33,268Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.14,196.86a10.89,10.89,0,0,1,1.68-2c1.09-1.15,2.62-2.7,4.33-4.39s3.29-3.19,4.45-4.25a10.55,10.55,0,0,1,2-1.64,11.92,11.92,0,0,1-1.67,1.94c-1.09,1.15-2.62,2.71-4.34,4.4s-3.3,3.2-4.46,4.26A11.13,11.13,0,0,1,693.14,196.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625,197a11.52,11.52,0,0,1-1.95-1.68c-1.15-1.09-2.7-2.62-4.39-4.33s-3.19-3.29-4.26-4.45a11.08,11.08,0,0,1-1.64-2,11.52,11.52,0,0,1,2,1.68c1.15,1.08,2.7,2.62,4.4,4.33s3.2,3.3,4.26,4.46A10.22,10.22,0,0,1,625,197Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.14,267.65s0-.12,0-.34,0-.57,0-1q0-1.33,0-3.84c0-3.36,0-8.25-.07-14.46,0-12.44-.08-30.15-.13-51.35l.26.26-67.9,0h0l.3-.3c0,26.05,0,50.43,0,71l-.26-.26,49.17.13,13.81.07,3.66,0,.94,0h.33a1.57,1.57,0,0,1-.3,0h-.92l-3.6,0-13.75.07-49.34.13H625v-.26c0-20.55,0-44.93,0-71v-.3h.31l67.9,0h.26v.27c0,21.27-.1,39-.13,51.51,0,6.19,0,11.06-.07,14.41,0,1.64,0,2.91,0,3.78,0,.41,0,.73,0,1A1.64,1.64,0,0,1,693.14,267.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.92,
    y: 220.8,
    width: 22.72,
    height: 22.72,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.22,337.57c6.55-3.38,14.27-3.82,21.54-2.62,3.91.65,8,1.82,10.64,4.75s3.17,8.1.11,10.63c-1.82,1.5-4.35,1.72-6.71,1.7-5.69-.07-12-1.07-16.56,2.36-2.6,1.95-4.32,5.2-7.43,6.16s-6.46-.85-8.07-3.59a12.54,12.54,0,0,1-.91-9.25A14.12,14.12,0,0,1,101.22,337.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2,308.59c4,5.72,11.8,3.83,15.41.33s5.14-8.55,6.53-13.38c3.17-11,6.37-22.6,4-33.84a18.87,18.87,0,0,0-4.32-9.2c-2.36-2.49-6-4-9.31-3.09-3.92,1-6.36,4.88-8.13,8.54a80.68,80.68,0,0,0-8,34.61c0,5.58.64,11.42,3.78,16",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2,316.8c4.35-5.16,5.18-12.7,3.24-19.16s-6.31-12-11.35-16.47a61.25,61.25,0,0,0-20.32-12,21.66,21.66,0,0,0-9.14-1.55c-3.1.29-6.23,1.88-7.67,4.64-2.14,4.08-.09,9,2.13,13.06a154.45,154.45,0,0,0,13.35,20.33c4,5.16,8.58,10.25,14.68,12.58s12.43,2.06,15.66-2.17",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.93,394.91a11.9,11.9,0,0,0,.37-2.6c.18-1.89.41-4.27.69-7.09a101.89,101.89,0,0,1,1.59-10.41,79.85,79.85,0,0,1,3.79-12.29,45.4,45.4,0,0,1,6.27-11.12,23.64,23.64,0,0,1,7.93-6.59,22.42,22.42,0,0,1,6.68-2.08,13.05,13.05,0,0,0,2.59-.37,11.45,11.45,0,0,0-2.64,0,20.25,20.25,0,0,0-7,1.81,23.38,23.38,0,0,0-8.37,6.65,44.4,44.4,0,0,0-6.5,11.34,75.15,75.15,0,0,0-3.76,12.49,90.19,90.19,0,0,0-1.38,10.54c-.23,3-.31,5.45-.35,7.14A12.44,12.44,0,0,0,85.93,394.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.42,389.45a4.84,4.84,0,0,0,.07-1.2c0-.91,0-2.05,0-3.45,0-3,0-7.33.16-12.68.26-10.71,1.18-22.22,3-38.46,1.69-15.27,4-33,6.34-44.59.51-2.63,1-5,1.51-7.07s.86-3.86,1.24-5.31.59-2.47.81-3.35a5.75,5.75,0,0,0,.21-1.19,4.81,4.81,0,0,0-.42,1.13c-.27.87-.6,2-1,3.31s-.9,3.21-1.42,5.27-1.11,4.42-1.67,7.05a387.74,387.74,0,0,0-6.66,41.38c-1.79,16.27-2.59,31.08-2.66,41.81-.07,5.37.05,9.71.19,12.71.08,1.4.15,2.54.21,3.44A6,6,0,0,0,86.42,389.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.49,360.88a21.31,21.31,0,0,0,0-3.61,97.28,97.28,0,0,0-1.11-9.76,128,128,0,0,0-3.17-14.23,117.74,117.74,0,0,0-6-16.84c-4.94-11.7-11.64-21.27-17.47-27.2a43.24,43.24,0,0,0-4.11-3.82c-.63-.54-1.19-1.07-1.76-1.49l-1.59-1.1a23.2,23.2,0,0,0-3-1.94c-.17.23,4.3,2.86,9.95,8.87a94.54,94.54,0,0,1,17,27.11,133.22,133.22,0,0,1,6,16.68c1.56,5.23,2.59,10,3.38,14.09s1.17,7.37,1.43,9.67A25.4,25.4,0,0,0,86.49,360.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.87 411.29 61.74 450.51 112.13 450.51 115 411.29 58.87 411.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.01,
    y: 395.82,
    width: 67,
    height: 15.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.01 449.01 54.01 453.3 57.15 453.3 119.9 453.3 119.9 449.01 54.01 449.01",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.24 460.84 57.15 453.3 117.5 453.3 113.9 460.84 60.24 460.84",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.06,424.11a1.88,1.88,0,0,1-.23.36l-.76,1-2.93,3.75-.13.17-.13-.18-7.21-10h.41c-2.14,3-4.53,6.42-7.1,10.05l-.22.32-.25-.3-8.42-10h.48l-.46.58-7.53,9.44-.25.31-.23-.32L72,419.24l.42,0-8.75,10-.16.18-.12-.2-2.74-4.6-.7-1.23a2,2,0,0,1-.22-.44,2,2,0,0,1,.3.39l.78,1.18L63.67,429l-.27,0L72,418.92l.21-.26.2.28,7.17,10-.48,0,7.51-9.45.46-.58.24-.3.25.29c3,3.52,5.78,6.92,8.4,10l-.47,0,7.17-10,.21-.29.2.29L110.14,429h-.25l3-3.66.82-.95Q114,424.1,114.06,424.11Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.7,411c0,.17-12.63.31-28.2.31s-28.21-.14-28.21-.31,12.63-.32,28.21-.32S115.7,410.85,115.7,411Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.24,453.72c0,.18-13.72.32-30.65.32s-30.65-.14-30.65-.32,13.72-.31,30.65-.31S118.24,453.55,118.24,453.72Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M667.57,381.67C656.12,335.68,628.9,260,626.38,254c-6.56-15.58-34.77-17.85-34.77-17.85l-38.43-6.41s-48.38,10.87-56,12.41c-.32.06-20.61,10.16-28.46,14.07h0a19.81,19.81,0,0,0-2.82,1.41l-.23.11v0c-5.55,3.31-17.09,12.69-20.95,34.88-3.58,20.54.53,77.6.53,77.6l-20.4-46.19-44.26,18.58,16.81,62a65.88,65.88,0,0,0,29.3,45.21c8.31,5.29,17.18,8.24,25.33,6.1l5.07-.81c5.36-1.41,10-6.23,14.06-12.45l1.79,17.6H631.84L626.68,431c14.94-2.74,27-5.79,32.64-9.06C666.71,417.63,671.06,395.68,667.57,381.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.27,422.48l-.69.33-2,.91L652.11,425c-1.38.42-3,1-4.77,1.47-3.63,1-8.12,2.11-13.39,3.24s-11.34,2.22-18.09,3.33c-27,4.41-65.05,8.72-108.54,12.1l-.26,0,0-.27c-.48-11.88-1-24.21-1.5-36.83-.14-3.34-.28-6.67-.41-9.94v-.22l.21-.05,93.39-20.75-.16.27c-6.72-24.52-12.06-44.9-15.66-59.17-1.8-7.13-3.14-12.75-4-16.57-.43-1.91-.76-3.37-1-4.37s-.31-1.51-.31-1.51.14.51.38,1.49.59,2.46,1,4.36c.94,3.81,2.31,9.41,4.15,16.54,3.67,14.25,9.08,34.61,15.84,59.11l.06.22-.23.05-93.36,20.84.2-.26c.13,3.27.27,6.6.41,9.94.51,12.62,1,25,1.49,36.83l-.27-.24c43.48-3.36,81.53-7.6,108.53-11.92,6.75-1.09,12.8-2.18,18.08-3.25s9.77-2.15,13.4-3.17c1.81-.49,3.4-1,4.78-1.42l3.43-1.22,2.06-.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.4,245.92c.06.09-1.69,1.08-4.08,3.23l-.93.85-1,1c-.67.66-1.31,1.45-2,2.24a48,48,0,0,0-4,5.64A45.17,45.17,0,0,0,579.4,265a35.16,35.16,0,0,0-1.66,5.38c-.69,3.13-.63,5.15-.74,5.14a6.92,6.92,0,0,1,0-1.4,11.64,11.64,0,0,1,.11-1.65c0-.33.07-.67.11-1s.14-.74.21-1.14a32.72,32.72,0,0,1,1.57-5.47,43.34,43.34,0,0,1,3-6.28,45.06,45.06,0,0,1,4-5.68c.73-.79,1.38-1.58,2.08-2.23l1-1c.34-.28.66-.56,1-.83a20.79,20.79,0,0,1,1.72-1.35,11.31,11.31,0,0,1,1.37-.92A7.24,7.24,0,0,1,594.4,245.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.76,392.75a8.73,8.73,0,0,1-1.13-1c-.34-.35-.77-.78-1.3-1.24s-1.09-1-1.78-1.58a52.84,52.84,0,0,0-4.94-3.69,55.11,55.11,0,0,0-6.62-3.64,53.37,53.37,0,0,0-7.1-2.59,47.49,47.49,0,0,0-6-1.3c-.87-.16-1.67-.22-2.36-.31s-1.3-.14-1.79-.17a8.48,8.48,0,0,1-1.53-.16,8.05,8.05,0,0,1,1.54,0,17.91,17.91,0,0,1,1.81.08c.7.06,1.5.09,2.38.23a46.89,46.89,0,0,1,6.11,1.2,47.34,47.34,0,0,1,13.85,6.3,45.36,45.36,0,0,1,4.93,3.82c.68.57,1.23,1.15,1.74,1.64a17.27,17.27,0,0,1,1.24,1.31A8.48,8.48,0,0,1,632.76,392.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.92,456.1a2.07,2.07,0,0,1-.07-.35c0-.26-.09-.61-.16-1-.13-.95-.32-2.29-.55-4-.48-3.48-1.12-8.51-1.88-14.74-1.53-12.45-3.46-29.67-5.52-48.7s-3.94-36.26-5.37-48.72c-.72-6.2-1.31-11.24-1.71-14.75-.2-1.72-.35-3.07-.46-4-.05-.43-.08-.78-.11-1a2,2,0,0,1,0-.36,1.29,1.29,0,0,1,.07.35c0,.26.1.61.16,1,.13,1,.32,2.29.56,4,.47,3.48,1.11,8.51,1.87,14.74,1.53,12.45,3.46,29.67,5.53,48.71s3.93,36.25,5.37,48.71c.72,6.2,1.3,11.24,1.71,14.75.19,1.72.35,3.07.45,4l.11,1A2,2,0,0,1,472.92,456.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.89,325.45l-.32.07-.94.15-3.62.53c-1.57.23-3.5.49-5.74.77s-4.79.61-7.61.92c-11.29,1.31-26.93,2.71-44.21,4.12s-32.93,2.75-44.22,4c-2.83.29-5.38.59-7.62.84s-4.18.48-5.75.68l-3.63.44-1,.1a1.62,1.62,0,0,1-.33,0,1.09,1.09,0,0,1,.32-.07l.94-.15,3.62-.54c1.57-.23,3.5-.49,5.74-.77s4.79-.61,7.62-.91c11.29-1.32,26.93-2.72,44.21-4.13s32.92-2.75,44.22-4c2.82-.28,5.38-.59,7.62-.84s4.17-.48,5.75-.68l3.63-.44,1-.1A1.11,1.11,0,0,1,584.89,325.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.11,336.25l-.32.06-1,.14-3.67.46c-3.19.39-7.81.94-13.52,1.57-11.42,1.27-27.22,2.89-44.69,4.46s-33.3,2.81-44.77,3.6c-5.73.4-10.37.69-13.58.88l-3.7.19-1,0a1.37,1.37,0,0,1-.33,0,1.23,1.23,0,0,1,.33,0l1-.09,3.68-.3,13.57-1c11.46-.88,27.29-2.17,44.76-3.75s33.26-3.13,44.69-4.31l13.54-1.4,3.68-.37,1-.08A1.17,1.17,0,0,1,587.11,336.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.63,301.29c0,.14-12.92,3.3-28.92,7.06s-29,6.69-29,6.55,12.91-3.3,28.91-7.06S641.6,301.15,641.63,301.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.17,318.38s0,0,0,0a.29.29,0,0,1-.11.06l-.43.14c-.38.11-.95.26-1.68.43-1.47.36-3.6.84-6.23,1.41-5.26,1.15-12.55,2.68-20.6,4.32s-15.36,3.08-20.65,4.1L591.24,330l-1.71.29a2.13,2.13,0,0,1-.61.07,3.1,3.1,0,0,1,.59-.17l1.69-.39,6.24-1.34,20.61-4.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.29,341.61A18.11,18.11,0,0,1,457,342l-5.47.73c-2.14.28-4.08.49-5.49.59a7.23,7.23,0,0,1-2.3,0,18.11,18.11,0,0,1,2.26-.35l5.47-.73c2.14-.28,4.08-.49,5.5-.59A7.18,7.18,0,0,1,459.29,341.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460,353.14a57.78,57.78,0,0,1-7.78,1.35,59.65,59.65,0,0,1-7.85.84A60.15,60.15,0,0,1,452.1,354,62,62,0,0,1,460,353.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.75,325.35,419,306.77s-13.18-41.23-13.94-45.36c-.88-4.76-3.39-5.48-5.13-5-2.7.69-4,4.43-3.38,8.54.22,1.42,4.55,23.7,4.55,23.7a52.64,52.64,0,0,0-5.44-5.22c-4.08-3.56-12.27-4.51-20.17-2.77s-10,2.92-9.44,6a4,4,0,0,0,2.12,2.71,11.43,11.43,0,0,0,6.59.9c15.31-2.59,16.39,3.49,16.39,3.49l.94,2.49s-9.1-4.15-14.82-.66a7.49,7.49,0,0,0-2.18,2A10.14,10.14,0,0,0,369.21,314c1.1,1.31,2.88,2.39,4.47,1.75a5.35,5.35,0,0,0,2-1.79,8.83,8.83,0,0,1,1-1.05l2.7,6.57s6.85,14.43,9.12,21.05",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.8,324.5c-2.22,1.08-4.94-.19-6.59-2s-2.62-4.18-4.13-6.13c-4.52-5.82-13.12-7.4-17.36-13.44-.59-.84-1.05-2.06-.36-2.82s1.79-.45,2.69-.15l23.18,7.71",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.23,307.65a10,10,0,0,0-2.42-1.09c-1.59-.62-3.9-1.46-6.77-2.48L398,300.56l-2.93-1c-.95-.24-2.08-1-3.64-.34a2.06,2.06,0,0,0-1.05,2.06,4.18,4.18,0,0,0,.71,1.87,16.17,16.17,0,0,0,2.38,2.71c3.61,3.23,7.81,4.91,11,7.16a18.47,18.47,0,0,1,4.13,3.65c1.07,1.34,1.86,2.81,2.73,4.09,1.63,2.66,4.07,4.18,5.85,4.33s2.69-.57,2.63-.59a6.88,6.88,0,0,1-2.53.06,8.35,8.35,0,0,1-5.12-4.33c-.79-1.27-1.53-2.78-2.65-4.27a19,19,0,0,0-4.31-4c-3.33-2.39-7.49-4.13-10.82-7.14a14.94,14.94,0,0,1-2.16-2.44c-.57-.84-.69-1.77-.18-2s1.59.06,2.58.39l2.94,1L407.73,305c2.91.9,5.27,1.61,6.91,2.07A10,10,0,0,0,417.23,307.65Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.08,296.24a10.11,10.11,0,0,0-2.26-4,7.78,7.78,0,0,0-4.41-2.09,19.84,19.84,0,0,0-6.18.25,31.59,31.59,0,0,1-6.4.63,10.31,10.31,0,0,1-5.13-1.47,4,4,0,0,1-1.87-3.06,2.3,2.3,0,0,1,.2-1.31,10.29,10.29,0,0,1,.15,1.26,3.77,3.77,0,0,0,1.87,2.58,10.17,10.17,0,0,0,4.8,1.17,35.39,35.39,0,0,0,6.24-.69,19.63,19.63,0,0,1,6.46-.18,8.14,8.14,0,0,1,4.73,2.47,7.32,7.32,0,0,1,1.7,3.16A2.52,2.52,0,0,1,392.08,296.24Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.32,263.32a24.18,24.18,0,0,1,.89,4.42c.54,3.05,1.17,6.68,1.88,10.7l2,10.67a25,25,0,0,1,.73,4.45,21.22,21.22,0,0,1-1.35-4.31c-.7-2.7-1.53-6.46-2.3-10.65s-1.31-8-1.62-10.77A20.63,20.63,0,0,1,396.32,263.32Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,302.21a5.93,5.93,0,0,1-1.39-.26,4.15,4.15,0,0,0-3.45.47,2.22,2.22,0,0,0-.81,2.07,11.38,11.38,0,0,0,.74,2.84,5.05,5.05,0,0,1,.12,3.59,4.27,4.27,0,0,1-3.07,2.4,4.89,4.89,0,0,1-3.77-.86,6.08,6.08,0,0,1-2.22-2.8,19.66,19.66,0,0,1-1-5.72,11.78,11.78,0,0,1,.45-3.88,2.7,2.7,0,0,1,.71-1.26c.07.05-.18.48-.37,1.35a13.71,13.71,0,0,0-.15,3.76,21.26,21.26,0,0,0,1.11,5.46c.71,1.77,2.83,3.52,5,3.07a3.47,3.47,0,0,0,2.45-1.87,4.29,4.29,0,0,0-.11-3,12.22,12.22,0,0,1-.7-3.06,2.9,2.9,0,0,1,1.18-2.61,4.38,4.38,0,0,1,3.93-.3C387.56,301.91,388,302.15,388,302.21Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.59,311.71s.25.44.11,1.29a3.94,3.94,0,0,1-2.16,2.77,5.22,5.22,0,0,1-5.16-.6,8.56,8.56,0,0,1-3.28-5.46,10.37,10.37,0,0,1,.8-6.31,9.92,9.92,0,0,1,3.39-3.94,9.24,9.24,0,0,1,3.18-1.4,2.65,2.65,0,0,1,1.27-.11,15.65,15.65,0,0,0-4.08,2,9.61,9.61,0,0,0-3.67,9.56,7.94,7.94,0,0,0,2.87,5,4.63,4.63,0,0,0,4.42.69,3.74,3.74,0,0,0,2.08-2.28C376.59,312.18,376.51,311.72,376.59,311.71Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.73,323.76a3.75,3.75,0,0,1,2.14-.36,8.48,8.48,0,0,1,5.16,1.94l-.71.36a27.79,27.79,0,0,1-.06-3.06c.23-6,2.69-10.31,2.87-10.17s-1.76,4.44-2,10.2c0,1,0,2,0,3l.06,1-.77-.66a8.8,8.8,0,0,0-4.65-2.06A20.07,20.07,0,0,1,394.73,323.76Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.24,285.88c.23.06-.34,1.82-2.14,3s-3.63,1.09-3.61.85,1.55-.52,3.11-1.59S387,285.76,387.24,285.88Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.56,395.81c-.79-.17-24.16,2.54-24.16,2.54S430,405,432,407.94s5.29,5.87,9.18,4.05,10.38-4.31,12.19-4.12,12.26,4.93,12.26,4.93l8.15-4.4Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "505.64 403.01 492.02 401.31 492.84 402.11 494.75 437.42 507.3 435.8 505.64 403.01",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.55,400.17c-.88-.57-21.21-7.7-26.65-9.6a4.1,4.1,0,0,0-2.68,0c-4.4,1.5-18.17,6.3-19.28,7.93-1.27,1.89-.35,5,3.5,5.2s14.4-.14,14.4-.14,3.05-.78,3.29.92-2.37,5.23-2.37,5.23S432,430,429.72,432.48c-1.59,1.73-.07,4.8,3,4.15,3.58-.77,33.52-16.3,33.52-16.3s2.53,1.57.38,2.95-21.31,17.53-23.34,19.4c-1.87,1.72-.92,5.29,3.17,5.36s28.41-16.39,28.41-16.39.87,6.35-1,9.23c-1.15,1.78-5.12,7.22-7.56,11.72a5.65,5.65,0,0,0,2.86,8h0l15-17.14,3.42-5.12s3.27,1.94,7.17-.9a19.06,19.06,0,0,0,7.36-11.13C503,422.18,498.09,405.1,490.55,400.17Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.14,419.89c-.12.07-2.62-4.11-5.57-9.33s-5.24-9.51-5.12-9.58,2.62,4.1,5.57,9.33S502.27,419.82,502.14,419.89Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.77,400.22a13.07,13.07,0,0,0,.27-3.75,12.94,12.94,0,0,0-1.29-3.53s.4.23.81.83a6.41,6.41,0,0,1,.76,5.43C465.09,399.88,464.82,400.25,464.77,400.22Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.61,278.93h0a28.12,28.12,0,0,1-29.54-24l-3.65-24.76s-23.4-.1-27.14-22.92-7.72-75.9-7.72-75.9h0C483.3,116,515.51,106.21,541,120.32l2.69,11.12,9.25,117.2A28.13,28.13,0,0,1,526.61,278.93Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.33,228.6s14.62-1,28.52-13c0,0-4.56,17.51-27.68,18.9Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.45,154.27c.36-.22,15-7,16.86,8.68S547,177.29,547,176.84,544.45,154.27,544.45,154.27Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551,170.32c.06,0,.3.16.78.32a2.78,2.78,0,0,0,2-.2c1.59-.81,2.67-3.61,2.41-6.45a9.11,9.11,0,0,0-1.23-3.82,3.18,3.18,0,0,0-2.3-1.86,1.41,1.41,0,0,0-1.53.95c-.16.46,0,.76-.1.8s-.37-.23-.32-.89a1.8,1.8,0,0,1,.5-1.06,2.11,2.11,0,0,1,1.47-.58,3.86,3.86,0,0,1,3.14,2.1,9.29,9.29,0,0,1,1.47,4.26c.28,3.18-1,6.33-3.18,7.26a3,3,0,0,1-2.55-.12C551.11,170.7,551,170.36,551,170.32Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.08,168.32a3.3,3.3,0,0,0,3.65,2.81,3.15,3.15,0,0,0,2.92-3.45,3.31,3.31,0,0,0-3.64-2.82A3.16,3.16,0,0,0,470.08,168.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.75,161.62c.47.36,2.67-1.84,6.18-2.37s6.35.85,6.67.36c.16-.22-.37-.92-1.62-1.57a9,9,0,0,0-5.41-.81,8.63,8.63,0,0,0-4.84,2.41C467.77,160.63,467.52,161.46,467.75,161.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.22,163.17a3.3,3.3,0,0,0,3.65,2.81,3.16,3.16,0,0,0,2.92-3.45,3.32,3.32,0,0,0-3.65-2.82A3.16,3.16,0,0,0,504.22,163.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.38,157.05c.47.36,2.67-1.84,6.18-2.36s6.35.84,6.67.35c.16-.21-.37-.92-1.62-1.57a9.11,9.11,0,0,0-5.42-.81,8.76,8.76,0,0,0-4.84,2.41C502.4,156.06,502.15,156.89,502.38,157.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.57,185c0-.21-2.25-.25-5.86-.17-.91,0-1.79,0-2-.6a4.6,4.6,0,0,1,.2-2.75q.76-3.44,1.61-7.23c2.22-10.28,3.67-18.68,3.26-18.76S488.2,163.7,486,174c-.52,2.53-1,4.94-1.5,7.25-.18,1.07-.59,2.32.07,3.59a2.25,2.25,0,0,0,1.67,1.09,6.14,6.14,0,0,0,1.56,0C491.38,185.55,493.59,185.23,493.57,185Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.66,140.11c.49.9,3.93-.08,8.13-.21s7.7.5,8.11-.44c.19-.45-.53-1.26-2-2a14.12,14.12,0,0,0-12.38.5C501.09,138.81,500.45,139.68,500.66,140.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.12,148.81c.74.71,3-.49,5.93-1s5.46-.27,5.9-1.19c.19-.45-.32-1.19-1.51-1.78a8.73,8.73,0,0,0-9.54,1.75C467,147.59,466.79,148.47,467.12,148.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.24,117.37a8.55,8.55,0,0,1,2-8c2-2,5.64-2.45,7.84-.59a7.07,7.07,0,0,1,4.72-9.38c3.7-.8,7.3,1.53,11.05,2s7.31-1,10.49-2.85,6.05-4.23,9.29-6a29.56,29.56,0,0,1,40,11.51c4.76-2.32,10.82-.64,14.55,3.13s5.35,9.21,5.53,14.5a48.36,48.36,0,0,1-1.07,10.65c0,.3.12.58.16.88,1.66,12.6,2.48,27.57-2.87,28.47-9.33,1.55-9.76-16.39-9.76-16.39-12.14-2.7-10.47-20.53-13.73-22.7s-10.18-7.32-32.34,8.58c-8.6,6.18-21,7.9-28,7.39l-.62,0h-.14a1.29,1.29,0,0,1-.21-.05,21.58,21.58,0,0,1-6.56-1.68,12.37,12.37,0,0,1-5.93-4.87,6.76,6.76,0,0,1,.23-7.36A14.8,14.8,0,0,1,445.24,117.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.75,196.28a16.12,16.12,0,0,0,2.64,3.69,5.36,5.36,0,0,0,4.1,1.61,4.81,4.81,0,0,0,3.7-2.8,7.71,7.71,0,0,0,.43-4.75c-.29-1.43-1.21-3.05-2.67-3a3.51,3.51,0,0,0-1.68.64l-7.08,4.2",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.17,202c0-.24,1.76.18,3.95-1.11a5.77,5.77,0,0,0,2.62-3.22,6.08,6.08,0,0,0-.65-4.94,5.23,5.23,0,0,0-.82-1c-.35-.27-.29-.26-.61-.17s-.76.44-1.14.66l-1.16.69c-1.51.9-2.89,1.69-4.05,2.34-2.33,1.29-3.82,2-3.92,1.86s1.21-1.18,3.41-2.68c1.1-.75,2.42-1.63,3.9-2.59l1.14-.73c.41-.24.72-.49,1.29-.77a1.76,1.76,0,0,1,1.12-.14,2.11,2.11,0,0,1,.93.53,6.61,6.61,0,0,1,1.07,1.3,7.14,7.14,0,0,1,.68,6.07,6.46,6.46,0,0,1-3.36,3.67,6.18,6.18,0,0,1-3.25.63C496.54,202.31,496.15,202.11,496.17,202Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.86,125.34s12.58,3.37,17.64,2.1,8.17-5.78,8.17-5.78a97.82,97.82,0,0,1-.91,11.53,31,31,0,0,1-22,3.1A80.84,80.84,0,0,1,524.86,125.34Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.93,347.27l-8.86,16.15s12.66-49.45-5.36-65.73l-.07-.06a23.16,23.16,0,0,0-1.71-2c-2.91-3-6.65-6.77-11.25-8.86h0a19.1,19.1,0,0,0-2.8-1l-53.46-1.92c-1.85.89-23.14,5.49-34.06,9.26h0a20.79,20.79,0,0,0-2.62,1,18.14,18.14,0,0,0-2.7,1.3l0,.06c-5.83,3.18-15,10.25-20.4,24.75C110.74,333.2,89.85,385,85.45,406.09a33.45,33.45,0,0,0,16.64,36.15L90.35,460.58H211.91l4.15-13.72c7.9.83,27.53,1.51,37.76-10.45,14.61-17.08,36-75.88,36-77.19Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,392.74c-.13-.07,4.91-10.3,11.26-22.85s11.59-22.68,11.72-22.62-4.91,10.3-11.26,22.85S236.08,392.8,236,392.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.44,320.61a2.55,2.55,0,0,1,.05.37c0,.27,0,.63.08,1.09.05.95.2,2.37.21,4.19a100.82,100.82,0,0,1-.84,15.42,172.09,172.09,0,0,1-4.53,22.45c-1.1,4.17-2.35,8.51-3.71,13s-2.83,9.11-4.2,13.89c-2.75,9.55-5,18.75-7.13,27.1s-4,15.89-5.62,22.19-3.07,11.39-4.12,14.88c-.51,1.75-1,3.09-1.25,4-.14.43-.25.78-.34,1a1.59,1.59,0,0,1-.13.35,2.07,2.07,0,0,1,.08-.36l.29-1.05,1.15-4c1-3.5,2.35-8.6,4-14.91s3.44-13.86,5.51-22.22,4.35-17.56,7.1-27.13c1.37-4.78,2.86-9.4,4.22-13.89s2.62-8.82,3.73-13a175.9,175.9,0,0,0,4.62-22.37,104.14,104.14,0,0,0,1-15.37c0-1.82-.08-3.23-.1-4.19,0-.46,0-.82,0-1.09A2.12,2.12,0,0,1,243.44,320.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.28,333.71c-.12,0,.17-2.11-.18-5.47-.06-.42-.11-.86-.17-1.31s-.18-.92-.27-1.41a27.12,27.12,0,0,0-.79-3.06,34.07,34.07,0,0,0-3-6.59,33.67,33.67,0,0,0-4.41-5.73c-.8-.77-1.54-1.53-2.32-2.14-.39-.31-.74-.64-1.11-.91l-1.08-.76c-2.79-1.9-4.78-2.64-4.73-2.75a8.22,8.22,0,0,1,1.38.52,12.15,12.15,0,0,1,1.57.76,18.22,18.22,0,0,1,2,1.16l1.12.75c.38.26.75.59,1.14.89.81.61,1.57,1.37,2.4,2.14a33.23,33.23,0,0,1,4.5,5.8,32.6,32.6,0,0,1,3,6.72,27.62,27.62,0,0,1,.76,3.12c.08.49.19,1,.24,1.43s.09.91.13,1.34a18.89,18.89,0,0,1,.09,2.3,12.65,12.65,0,0,1-.07,1.73A7.22,7.22,0,0,1,157.28,333.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.79,398.34a2.1,2.1,0,0,1,.1-.53c.1-.4.23-.89.38-1.49.38-1.36.89-3.21,1.51-5.45,1.3-4.6,3.13-10.95,5.2-17.94s4-13.31,5.45-17.86c.72-2.28,1.33-4.12,1.78-5.38.22-.63.4-1.11.55-1.44a2,2,0,0,1,.18-.36s.08-.1.08-.06,0,.05,0,.05-.05.07-.17.41l-.45,1.47c-.41,1.35-1,3.18-1.62,5.42-1.37,4.65-3.24,10.94-5.3,17.9s-4,13.25-5.34,17.89c-.69,2.23-1.26,4.06-1.67,5.41-.2.59-.35,1.07-.48,1.46A2.2,2.2,0,0,1,138.79,398.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.26,397.69l.34,0,1-.09,4-.29,14.92-1,52.18-3.47h.22l0,.22c1.51,10.84,3.17,22.74,4.91,35.18l0,.22-.22.06-7.14,2c-15.36,4.27-30.06,8.2-43.6,11-6.77,1.42-13.24,2.58-19.32,3.5s-11.76,1.67-17,2a64.51,64.51,0,0,1-14.11-.38,44.38,44.38,0,0,1-10.39-2.33,19.82,19.82,0,0,1-5.78-3.44,13.39,13.39,0,0,1-1.27-1.2c-.28-.29-.41-.44-.41-.44s.16.13.44.4a16,16,0,0,0,1.31,1.16,20.06,20.06,0,0,0,5.78,3.33,44.78,44.78,0,0,0,10.36,2.23,64.22,64.22,0,0,0,14,.3c5.2-.39,10.87-1.18,16.95-2.1s12.52-2.11,19.28-3.54c13.52-2.84,28.2-6.78,43.56-11.05l7.14-2-.19.29c-1.72-12.44-3.37-24.34-4.86-35.18l.25.21-52.19,3.27-14.93.9-4,.21-1,.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,371.55a1.23,1.23,0,0,1-.26.2l-.78.54a18,18,0,0,1-3.29,1.6,18.24,18.24,0,0,1-5.69,1,17.77,17.77,0,0,1-7.51-1.49,18.61,18.61,0,0,1-7.21-5.82,21.51,21.51,0,0,1-4.14-9.8,21.75,21.75,0,0,1,1.58-11.64,18.79,18.79,0,0,1,8.36-9.36,9.36,9.36,0,0,1,6.4-.78,6,6,0,0,1,4.15,4.58,12.34,12.34,0,0,1-.32,6.05,16.78,16.78,0,0,1-11.12,11.43,13.49,13.49,0,0,1-4.84.54,13.85,13.85,0,0,1-4.35-1.11,16.15,16.15,0,0,1-6-4.68,17.06,17.06,0,0,1-2.86-5,16.63,16.63,0,0,1-.6-2c-.1-.61-.22-1.11-.26-1.53l-.07-.95a1.93,1.93,0,0,1,0-.32,20.26,20.26,0,0,0,1.13,4.75,17.39,17.39,0,0,0,2.89,4.92,16.17,16.17,0,0,0,6,4.53,14,14,0,0,0,4.23,1,12.87,12.87,0,0,0,4.68-.56,16.34,16.34,0,0,0,10.77-11.14,11.86,11.86,0,0,0,.3-5.8,5.48,5.48,0,0,0-3.79-4.2,8.81,8.81,0,0,0-6,.75,11.28,11.28,0,0,0-2.64,1.71,18.55,18.55,0,0,0-2.24,2.19,21.26,21.26,0,0,0-4.81,16.56,21.12,21.12,0,0,0,4,9.6,18.31,18.31,0,0,0,7,5.75,17.59,17.59,0,0,0,7.35,1.54,18.47,18.47,0,0,0,5.63-.94,19.79,19.79,0,0,0,3.31-1.5l.8-.49A1.54,1.54,0,0,1,146,371.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.74,336.89l-.46.41a15.19,15.19,0,0,1-1.42,1.14,19.36,19.36,0,0,1-6.33,2.93,22.31,22.31,0,0,1-11,.05,20.33,20.33,0,0,1-6.34-2.77l-.78-.51-.73-.6-.75-.6c-.24-.21-.45-.46-.68-.69a16.4,16.4,0,0,1-2.52-3.11,13.42,13.42,0,0,1-2.19-8.21,9.57,9.57,0,0,1,5-7.57,7.25,7.25,0,0,1,4.88-.57,9.36,9.36,0,0,1,4.42,2.51,10.77,10.77,0,0,1,2.71,4.48,13.75,13.75,0,0,1,.43,5.35A24.57,24.57,0,0,1,222,339.44a33.52,33.52,0,0,1-7.78,8.5,34.16,34.16,0,0,1-10.58,5.54,33.47,33.47,0,0,1-6,1.25,28.75,28.75,0,0,1-6.22,0A20.74,20.74,0,0,1,180.15,350a17.11,17.11,0,0,1-3.79-4.73,16,16,0,0,1-1.88-5.66,13.09,13.09,0,0,1,.54-5.84,12,12,0,0,1,3.11-4.84,11.75,11.75,0,0,1,10.3-3.36,9.49,9.49,0,0,1,4.74,2.53,11.72,11.72,0,0,1,2.79,4.43,15.05,15.05,0,0,1,0,9.85,15.74,15.74,0,0,1-5.62,7.3,23.77,23.77,0,0,1-7.7,3.71,32.77,32.77,0,0,1-7.67,1.22,29.71,29.71,0,0,1-6.91-.44,19.34,19.34,0,0,1-5.68-2,14,14,0,0,1-3.91-3.22,12,12,0,0,1-2.84-6.33,10,10,0,0,1,0-1.82c.05-.41.08-.61.08-.61s0,.21,0,.62a10.07,10.07,0,0,0,.07,1.8,12,12,0,0,0,2.88,6.21,14.08,14.08,0,0,0,3.88,3.13,19.22,19.22,0,0,0,5.61,1.94,32.7,32.7,0,0,0,14.43-.84,23.39,23.39,0,0,0,7.55-3.68,15.34,15.34,0,0,0,5.46-7.12,14.61,14.61,0,0,0-.07-9.55,11.32,11.32,0,0,0-2.68-4.25,9.09,9.09,0,0,0-4.52-2.4,11.25,11.25,0,0,0-9.85,3.25A11.73,11.73,0,0,0,175,339.49a15.27,15.27,0,0,0,1.82,5.49,16.92,16.92,0,0,0,3.68,4.59,20.34,20.34,0,0,0,11,4.61,27.66,27.66,0,0,0,6.1,0,32,32,0,0,0,16.32-6.68,32.73,32.73,0,0,0,7.68-8.36,24,24,0,0,0,3.88-10.09,13.39,13.39,0,0,0-.4-5.17,10.22,10.22,0,0,0-2.59-4.28,8.71,8.71,0,0,0-4.19-2.4,6.83,6.83,0,0,0-4.59.51,9.19,9.19,0,0,0-4.77,7.23,13,13,0,0,0,2.11,8,15.74,15.74,0,0,0,2.45,3.07c.22.22.43.46.67.67l.72.6.72.59.76.5a20.2,20.2,0,0,0,6.24,2.77,22.14,22.14,0,0,0,10.88,0,19.85,19.85,0,0,0,6.32-2.81c.68-.43,1.11-.86,1.45-1.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.94,366.61a2,2,0,0,1-.22.37c-.17.26-.41.61-.7,1.06s-.72,1-1.23,1.66c-.26.32-.52.67-.82,1l-1,1.13a41.62,41.62,0,0,1-26.6,13.39c-1.12.07-2.25.17-3.41.18a32.48,32.48,0,0,1-3.53-.18,21.64,21.64,0,0,1-7.1-1.95,13.33,13.33,0,0,1-5.76-5.14,11.78,11.78,0,0,1-1.51-7.89,8.52,8.52,0,0,1,1.74-3.83,7.88,7.88,0,0,1,3.49-2.46,10.61,10.61,0,0,1,8.49.76,9.77,9.77,0,0,1,3.33,2.86,11.61,11.61,0,0,1,1.83,3.92,14.73,14.73,0,0,1-.4,8.33,16.85,16.85,0,0,1-4.38,6.78,24.81,24.81,0,0,1-6.38,4.37,33.82,33.82,0,0,1-6.94,2.45c-1.15.3-2.32.47-3.46.69s-2.27.3-3.39.34a42.26,42.26,0,0,1-12.35-1.14,43.49,43.49,0,0,1-9.59-3.61,41.24,41.24,0,0,1-3.6-2.16,32.62,32.62,0,0,1-2.85-2.09c-.86-.63-1.51-1.32-2.13-1.86a16.34,16.34,0,0,1-1.45-1.46l-.86-.93a2.54,2.54,0,0,1-.28-.33l.32.29.89.9a19.59,19.59,0,0,0,1.49,1.42c.63.52,1.28,1.2,2.15,1.81a32.45,32.45,0,0,0,2.86,2,41.39,41.39,0,0,0,3.6,2.11,43.71,43.71,0,0,0,9.53,3.51A42,42,0,0,0,178,394.05c1.11,0,2.22-.24,3.36-.35s2.27-.4,3.41-.69a33.94,33.94,0,0,0,6.84-2.44,24.16,24.16,0,0,0,6.24-4.3,16.25,16.25,0,0,0,4.25-6.58,14.36,14.36,0,0,0,.38-8,9.9,9.9,0,0,0-4.9-6.45,10.18,10.18,0,0,0-8.08-.74,7.43,7.43,0,0,0-3.26,2.3,8,8,0,0,0-1.63,3.6,11.24,11.24,0,0,0,1.43,7.55,12.76,12.76,0,0,0,5.55,4.95,20.89,20.89,0,0,0,6.93,1.93A31.48,31.48,0,0,0,202,385c1.14,0,2.26-.09,3.37-.16a41.77,41.77,0,0,0,26.49-13.1l1-1.1c.31-.36.58-.71.84-1a20.55,20.55,0,0,0,1.26-1.63l.75-1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.1,442.83a5.76,5.76,0,0,1-.71-1,9.26,9.26,0,0,1-1-3.38,11.92,11.92,0,0,1,.8-5.52,21.81,21.81,0,0,1,4-6.23,48.06,48.06,0,0,1,6.44-6.24,23.72,23.72,0,0,1,9.19-4.62,16.79,16.79,0,0,1,5.59-.39,12.19,12.19,0,0,1,5.55,1.87,7,7,0,0,1,3.19,5.11,5.16,5.16,0,0,1-.68,3.11,6.23,6.23,0,0,1-2.33,2.2,9.44,9.44,0,0,1-6.18.81,23.43,23.43,0,0,1-5.79-1.76c-3.61-1.61-6.76-4.3-8.16-7.76a12.39,12.39,0,0,1-.91-5.26,15,15,0,0,1,1.1-4.91,15.66,15.66,0,0,1,5.56-7,19.05,19.05,0,0,1,6.8-2.9,23.48,23.48,0,0,1,5.57-.51,20.3,20.3,0,0,1,4.71.61l-.31,0-.9-.14a30.61,30.61,0,0,0-3.5-.25,23.9,23.9,0,0,0-5.5.6,19,19,0,0,0-6.66,2.91,15.25,15.25,0,0,0-5.37,6.85,14.47,14.47,0,0,0-1,4.77,11.91,11.91,0,0,0,.89,5.06c1.36,3.31,4.4,5.9,7.93,7.47A22.93,22.93,0,0,0,125,428a8.91,8.91,0,0,0,5.84-.75,5.7,5.7,0,0,0,2.14-2,4.63,4.63,0,0,0,.61-2.79,6.42,6.42,0,0,0-3-4.73,11.73,11.73,0,0,0-5.31-1.81,16.65,16.65,0,0,0-5.43.37,23.24,23.24,0,0,0-9,4.49,48.12,48.12,0,0,0-6.43,6.14,21.5,21.5,0,0,0-4,6.1,11.74,11.74,0,0,0-.86,5.39,9,9,0,0,0,.92,3.35C100.86,442.48,101.13,442.81,101.1,442.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.88,393.88a.83.83,0,0,1,.06.25c0,.2.06.45.11.76a7.88,7.88,0,0,1,.11,1.23,13.38,13.38,0,0,1,0,1.7,21.62,21.62,0,0,1-3,10.28,21.33,21.33,0,0,1-4.79,5.71,19.58,19.58,0,0,1-7.57,4A22.29,22.29,0,0,1,165,414.38c-.42-.34-.86-.67-1.27-1l-1.17-1.09-.1-.09,0-.14c.08-.49.16-1,.23-1.43l0-.13.12-.06a13.78,13.78,0,0,1,9.21-1.24,13.05,13.05,0,0,1,7.41,4.36,14,14,0,0,1,3.14,7.1,12.93,12.93,0,0,1-.83,6.68,13.72,13.72,0,0,1-6.51,7,11.6,11.6,0,0,1-2.45.93l-.66.14a.67.67,0,0,1-.23,0,17.21,17.21,0,0,0,3.26-1.27,13.78,13.78,0,0,0,6.27-7,12.68,12.68,0,0,0,.74-6.49,13.59,13.59,0,0,0-3.08-6.86,12.57,12.57,0,0,0-7.16-4.17,13.26,13.26,0,0,0-8.87,1.21l.14-.19c-.08.47-.16.95-.23,1.43l-.07-.22,1.14,1.06c.4.34.82.66,1.24,1a22,22,0,0,0,18.38,3.37,19.31,19.31,0,0,0,7.41-3.85,21.21,21.21,0,0,0,4.75-5.57,21.92,21.92,0,0,0,3.13-10.1,13.9,13.9,0,0,0,0-1.68,10.5,10.5,0,0,0-.06-1.23l-.06-.76A.74.74,0,0,1,198.88,393.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.27,295.66s.09.12.21.36a6.06,6.06,0,0,1,.4,1.13,8.21,8.21,0,0,1-1.55,7.1,7.84,7.84,0,0,1-2.8,2.16,8.63,8.63,0,0,1-3.82.79,8.15,8.15,0,0,1-4-1.19,40.91,40.91,0,0,1-3.38-2.35,10.88,10.88,0,0,0-3.29-1.73,6.63,6.63,0,0,0-5.87,1.38,7.1,7.1,0,0,0-2.39,3.46c-.28,1-.24,1.56-.31,1.55a2.18,2.18,0,0,1,0-.41,5.69,5.69,0,0,1,.14-1.19,7,7,0,0,1,2.36-3.7,7.8,7.8,0,0,1,2.69-1.47,6.38,6.38,0,0,1,3.53-.09c2.49.66,4.45,2.72,6.81,4.1a7.91,7.91,0,0,0,7.37.41,7.49,7.49,0,0,0,4.08-4.55,8.36,8.36,0,0,0,.27-4.22C178.48,296.2,178.22,295.68,178.27,295.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,392.21a11.8,11.8,0,0,1-1.36-1c-.86-.63-2.13-1.52-3.76-2.5a30.22,30.22,0,0,0-13.95-4.56,21.84,21.84,0,0,0-8,1.17,19.31,19.31,0,0,0-5.8,3.18,20.26,20.26,0,0,0-4,4.59s0-.15.17-.4a10.63,10.63,0,0,1,.62-1.07,15.08,15.08,0,0,1,3-3.4,19,19,0,0,1,5.87-3.35,21.7,21.7,0,0,1,8.18-1.24,29.43,29.43,0,0,1,14.13,4.76,34.93,34.93,0,0,1,3.68,2.66c.42.33.73.62.94.81S127,392.19,127,392.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.6,336.3a10.56,10.56,0,0,1-1.75-.18,15.6,15.6,0,0,1-2-.36,24.17,24.17,0,0,1-2.64-.66l-1.52-.46c-.53-.16-1.06-.39-1.61-.59-1.13-.4-2.27-1-3.48-1.52a45.41,45.41,0,0,1-7.33-4.67,44.79,44.79,0,0,1-6.19-6.1c-.82-1.06-1.63-2.05-2.26-3.06-.33-.49-.67-1-.94-1.43l-.79-1.38a25.33,25.33,0,0,1-1.23-2.43,17.19,17.19,0,0,1-.81-1.89,12.6,12.6,0,0,1-.56-1.66,11.81,11.81,0,0,1,.75,1.58c.22.52.5,1.14.88,1.84s.75,1.53,1.29,2.38l.81,1.34c.28.47.63.92,1,1.41.64,1,1.45,2,2.27,3a42.64,42.64,0,0,0,13.36,10.65c1.2.57,2.32,1.14,3.42,1.54.55.22,1.07.45,1.59.63l1.49.48c1,.34,1.84.52,2.61.73a16.86,16.86,0,0,0,2,.44A12.59,12.59,0,0,1,157.6,336.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,440.15a1.83,1.83,0,0,1-.51,0l-1.48-.07c-.64,0-1.42-.08-2.33-.06s-1.94,0-3.08.08l-1.79.11c-.62,0-1.26.15-1.92.23-1.34.13-2.74.43-4.23.7a57.63,57.63,0,0,0-9.35,2.93,56.89,56.89,0,0,0-8.64,4.62c-1.24.86-2.44,1.66-3.47,2.52-.52.42-1,.8-1.51,1.22l-1.33,1.19c-.88.74-1.57,1.51-2.22,2.15s-1.17,1.21-1.59,1.7l-1,1.1a2.65,2.65,0,0,1-.37.36s.08-.16.29-.43.54-.7.91-1.16a18.58,18.58,0,0,1,1.53-1.77c.63-.66,1.31-1.46,2.17-2.22l1.33-1.23c.46-.42,1-.82,1.51-1.25,1-.88,2.22-1.7,3.46-2.58a54.79,54.79,0,0,1,8.71-4.7,55.67,55.67,0,0,1,9.45-2.92c1.5-.26,2.92-.55,4.27-.66.68-.07,1.32-.17,1.95-.2l1.81-.08c1.15-.08,2.19,0,3.1,0s1.7.08,2.34.15l1.47.17A1.61,1.61,0,0,1,218,440.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.56,433.36a4.86,4.86,0,0,1-.66.49c-.44.29-1.09.73-2,1.25a27.69,27.69,0,0,1-7.9,3.33,17.22,17.22,0,0,1-5.95.36,13.68,13.68,0,0,1-6.4-2.39,10.32,10.32,0,0,1-4.08-6.3,9.54,9.54,0,0,1,0-4.05,7.94,7.94,0,0,1,2-3.68,8,8,0,0,1,13.23,2.71,9.3,9.3,0,0,1-.27,6.79,12.89,12.89,0,0,1-3.46,4.85,25.36,25.36,0,0,1-7.42,4.28c-.95.38-1.68.65-2.19.83a5,5,0,0,1-.77.24,4.2,4.2,0,0,1,.73-.34l2.15-.91a26.55,26.55,0,0,0,7.26-4.38,12.74,12.74,0,0,0,3.3-4.73,8.91,8.91,0,0,0,.23-6.46A7.51,7.51,0,0,0,230,422.73a7.26,7.26,0,0,0-1.85,3.43,9,9,0,0,0,0,3.83,9.91,9.91,0,0,0,3.86,6,13.32,13.32,0,0,0,6.18,2.35,16.8,16.8,0,0,0,5.81-.29,29.36,29.36,0,0,0,7.88-3.14c.89-.49,1.56-.9,2-1.17A4.63,4.63,0,0,1,254.56,433.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.48,374.74a6,6,0,0,1-1.73-1.36,14.82,14.82,0,0,1-4.24-9.56,5.94,5.94,0,0,1,.14-2.2,22.05,22.05,0,0,0,1.59,7.15A22.36,22.36,0,0,0,260.48,374.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.55,315.83a8,8,0,0,1-.22,2.36,13.94,13.94,0,0,1-2.18,5.3,9.48,9.48,0,0,1-2.27,2.25,9.12,9.12,0,0,1-2.32,1.16,8.59,8.59,0,0,1-1.7.4,1.58,1.58,0,0,1-.64,0c0-.1.88-.24,2.21-.76a9.76,9.76,0,0,0,4.3-3.37,15.62,15.62,0,0,0,2.24-5.08A17,17,0,0,1,253.55,315.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,322.91a4,4,0,0,1-.69-.9,15.84,15.84,0,0,1-1.46-2.78,18.44,18.44,0,0,1,3.31-19.4,16.32,16.32,0,0,1,2.29-2.14,3.93,3.93,0,0,1,1-.62,41,41,0,0,0-3,3,19,19,0,0,0-3.24,19A40,40,0,0,0,237,322.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.7,357a5.19,5.19,0,0,1-1.2,1.57,12.6,12.6,0,0,1-3.95,2.68,12.78,12.78,0,0,1-4.66,1,5.21,5.21,0,0,1-2-.21A16,16,0,0,0,251.7,357Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.74,458.42c-.06.05-.81-.9-2.13-2.31a39.63,39.63,0,0,0-5.66-5,39.16,39.16,0,0,0-6.54-3.77c-1.77-.81-2.91-1.21-2.88-1.29a2.77,2.77,0,0,1,.83.18,21.63,21.63,0,0,1,2.19.77,32,32,0,0,1,12.33,8.86c.64.75,1.12,1.38,1.43,1.83S148.77,458.4,148.74,458.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.93,350.9l25.27-51.35s29.1-13.17,31.57-11.32,16.05,14.2,16.05,14.2h0a8.72,8.72,0,0,1-10.07.27l-6.9-4.6-8.46,4,10.2,5.79,10.6,15.5s-5.25,2.47-6.79,1.24.92,2.73.92,2.73-5.86,2.7-8.25-.37c0,0-4.09,2.58-7.48-1.75l-3.4-4.32-6.48,6.48-9.37,32Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.07,312.4a95.14,95.14,0,0,1,6.9,12,46,46,0,0,1-3.68-5.88A48.09,48.09,0,0,1,313.07,312.4Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.13,305.72a142.74,142.74,0,0,1,29.55,7.18,4.69,4.69,0,0,1-2.32,3.21c-2.19.7-3.35.55-7-.29a44,44,0,0,1-4.73-1.18,16.68,16.68,0,0,1-4.8,7.67c-2.38,1.92-5.9,2.67-8.54,1.15",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.31,323.46s.42.21,1.24.45a7.19,7.19,0,0,0,3.65,0A9.18,9.18,0,0,0,300,321a18.79,18.79,0,0,0,3.48-6.42l.08-.22.22.07a25.7,25.7,0,0,0,3.14.81l3.38.74a10.14,10.14,0,0,0,3.51.26,7,7,0,0,0,1.7-.45,4.54,4.54,0,0,0,1.26-1.25,3.41,3.41,0,0,0,.7-1.63l.17.24a142.69,142.69,0,0,0-20.76-5.8c-2.69-.55-4.86-.94-6.37-1.19l-1.73-.3a2.88,2.88,0,0,1-.6-.13,2.44,2.44,0,0,1,.62,0c.4,0,1,.1,1.74.2,1.52.19,3.71.53,6.41,1a129,129,0,0,1,20.87,5.67l.18.06v.18a3.78,3.78,0,0,1-.8,1.93,5,5,0,0,1-1.42,1.4,7.2,7.2,0,0,1-1.89.51,10.69,10.69,0,0,1-3.68-.27l-3.39-.76a27.9,27.9,0,0,1-3.18-.84l.29-.15a18.88,18.88,0,0,1-3.63,6.53,9.52,9.52,0,0,1-5,3,7,7,0,0,1-3.75-.16A4.31,4.31,0,0,1,290.31,323.46Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.28,315.57a29.34,29.34,0,0,1,5.2,11.16c-.14,0-1-2.57-2.48-5.64S307.15,315.65,307.28,315.57Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.47,239.1c-5.22-6.26-11.6-12.67-11.83-20.82-.11-4.33,1.46-9.19-1.13-12.66-2.26-3-6.75-3.5-9.29-6.29-3.39-3.72-1.93-9.6-3.09-14.49-1.26-5.33-5.83-9.44-11-11.33s-10.78-1.85-16.22-1.22l-5.1,112.19c2.49-2.72,9-3.87,12.41-2.55s6.69,3.44,10.36,3.74c8.26.68,14.07-7.58,21.13-11.91,6.73-4.14,16-5.46,19.69-12.45C295.24,254.11,290.69,245.36,285.47,239.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.94,205.53c-.66-14.61-16.13-29.47-30.71-28.19l-47.33,8.14v7.85l1.19,97.31h0s2.48,24,29,22.71c23.81-1.18,24-18.93,24-18.93l-.25-13.7s18.7-2.77,23-27C253.93,241.62,253.67,221.77,252.94,205.53Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,274.61a8.7,8.7,0,0,0,2.75-1.13,6.11,6.11,0,0,0,2.17-2.6,6,6,0,0,0,.07-4.38c-.53-1.63-2-2.78-3.74-3.9a10.12,10.12,0,0,1-2.5-2.18,5.37,5.37,0,0,1-1.05-3.47c.14-2.53,1.44-4.72,2.27-7a10.27,10.27,0,0,0,.75-3.56,6.56,6.56,0,0,0-1.07-3.48c-1.39-2.14-3.55-3.66-5.57-5.14a30,30,0,0,1-5.61-4.77,23.48,23.48,0,0,1-5.38-11.18,22.07,22.07,0,0,1,0-8.36,13.61,13.61,0,0,1,.59-2.2,2.29,2.29,0,0,1,.3-.73c.11,0-.25,1.06-.5,3a23.94,23.94,0,0,0,5.72,18.86,29.91,29.91,0,0,0,5.49,4.58c2,1.48,4.29,3,5.85,5.41a7.46,7.46,0,0,1,1.22,4,11.2,11.2,0,0,1-.83,3.92c-.89,2.4-2.14,4.55-2.26,6.73a4.42,4.42,0,0,0,.83,2.89,9.21,9.21,0,0,0,2.27,2,18.32,18.32,0,0,1,2.39,1.88,6.52,6.52,0,0,1,1.31,7.32,6.36,6.36,0,0,1-2.48,2.71,5.87,5.87,0,0,1-2.16.78A1.6,1.6,0,0,1,270,274.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.43,222.4a3.13,3.13,0,0,1-3.07,3.09,3,3,0,0,1-3.17-2.87,3.13,3.13,0,0,1,3.06-3.1A3,3,0,0,1,245.43,222.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.45,215.78c-.4.4-2.73-1.39-6.09-1.44s-5.85,1.58-6.2,1.16c-.18-.18.23-.91,1.32-1.67a8.51,8.51,0,0,1,5-1.44,8.24,8.24,0,0,1,4.84,1.66C248.31,214.86,248.64,215.6,248.45,215.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.59,221.52a3.11,3.11,0,0,1-3.06,3.09,3,3,0,0,1-3.17-2.87,3.11,3.11,0,0,1,3.06-3.09A3,3,0,0,1,214.59,221.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.43,215.82c-.4.4-2.73-1.39-6.09-1.44s-5.85,1.58-6.2,1.16c-.18-.18.22-.91,1.32-1.67a8.51,8.51,0,0,1,5-1.44,8.24,8.24,0,0,1,4.84,1.66C215.28,214.9,215.62,215.64,215.43,215.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.17,240.94c0-.19,2.09-.52,5.48-.89.85-.07,1.67-.23,1.82-.81a4.34,4.34,0,0,0-.52-2.55q-1.15-3.13-2.42-6.58c-3.36-9.36-5.77-17.05-5.4-17.18s3.41,7.35,6.77,16.71c.8,2.31,1.58,4.51,2.31,6.61a5,5,0,0,1,.38,3.37,2.15,2.15,0,0,1-1.43,1.23,5.8,5.8,0,0,1-1.46.18C229.3,241.15,227.18,241.13,227.17,240.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.79,280.72a62,62,0,0,1-32.44-9.27s8.15,17,32.55,15.15Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.25,243.09c.55,0,.49,3.62,3.56,6.26s7,2.31,7,2.82c.05.23-.87.7-2.52.71a9,9,0,0,1-5.83-2.15,7.93,7.93,0,0,1-2.75-5.25C216.58,244,217,243.06,217.25,243.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.52,202.68c-.36,1.21-3.7.58-7.65,1.14s-7.16,1.93-7.67.83c-.22-.52.35-1.65,1.66-2.81a10.87,10.87,0,0,1,5.72-2.53,9.8,9.8,0,0,1,5.94,1C216,201.14,216.67,202.11,216.52,202.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.36,204.83c-.61,1.11-2.91-.09-5.69-.2s-5.15.66-5.67-.52c-.23-.57.16-1.69,1.21-2.73a6.22,6.22,0,0,1,4.66-1.76,6.47,6.47,0,0,1,4.49,2.34C247.33,203.13,247.63,204.29,247.36,204.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.3,214.15c8-9.81,19.49-28.18,30.59-33.05,1.77-.78,14.52-1.35,15.61-1.35a24.89,24.89,0,0,1,6.7,4.06c5.91,5.17,10.6,17.34,12.87,24.85,3.28-9.36,2.22-22.79-4.29-30.28s-13.41-11.62-23.31-12.12-17.35,1.73-25.79,6.93c-3.35,2.06-15.41,12.09-18.78,17.86Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.9,166.76c1.64.18-9.4-8.87-16.29-10.11a27.62,27.62,0,0,0-20,4.19c-3.94,2.64-7.22,6.31-11.58,8.17-3.32,1.41-7,1.65-10.47,2.67a24.33,24.33,0,0,0-16.89,21c-.3,4,.44,8.08.5,12.13s-.68,8.37-3.42,11.35c-2.38,2.59-5.87,3.77-8.84,5.64a21.9,21.9,0,0,0-9.7,21.54c.72,4.42,2.82,9,1.29,13.19-1,2.77-3.42,4.77-5,7.23a14.73,14.73,0,0,0,.53,16.55c4.12.45,7.37,3.54,10.57,6.17s7.3,5.06,11.28,3.89c5.16-1.51,7.61-8.41,12.93-9.17s9,4.79,13.95,6.66c5.62,2.12,12.19-1.08,15.59-6s4.22-11.22,4.34-17.23c.15-7.55-.81-15.52-5.28-21.61-3.21-4.36-8.3-8.1-8.37-13.51-.07-5.19,4.65-9.3,5.45-14.42.69-4.5-1.72-8.81-3.6-13s-5.32-10.28-2.69-14C184.13,188.06,202.07,163.67,229.9,166.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.62,220.31c0,.06-.3-.08-.83-.05a2.63,2.63,0,0,0-1.92,1.14,2.51,2.51,0,0,0,0,3.25,3.82,3.82,0,0,0,4.3.92,5.67,5.67,0,0,0,3-4.64,15.07,15.07,0,0,0-1.25-6.72c-.86-2.26-2.08-4.7-4.25-6.06a5.9,5.9,0,0,0-3.69-.77,24.45,24.45,0,0,0-4.08.91,12.43,12.43,0,0,1-4.4.59,5.76,5.76,0,0,1-3.92-2.07,10.43,10.43,0,0,1-1.83-7.82c.28-2.54.86-4.84.89-7a14.35,14.35,0,0,0-1.17-5.86,15.8,15.8,0,0,0-5.49-6.75c-1.73-1.17-2.86-1.54-2.82-1.63s.29,0,.83.22a13,13,0,0,1,2.21,1.08,15.53,15.53,0,0,1,5.93,6.79A14.88,14.88,0,0,1,264.5,192c0,2.3-.57,4.66-.8,7.1a9.5,9.5,0,0,0,1.66,7.09,4.74,4.74,0,0,0,3.25,1.7,11.53,11.53,0,0,0,4-.57,26,26,0,0,1,4.26-.93,6.92,6.92,0,0,1,4.3.93c2.51,1.61,3.73,4.24,4.61,6.58A15.73,15.73,0,0,1,287,221a6.45,6.45,0,0,1-3.58,5.2,4.42,4.42,0,0,1-5-1.24,2.88,2.88,0,0,1-.62-2.15,3.31,3.31,0,0,1,.77-1.7,2.81,2.81,0,0,1,2.23-1.1A1.42,1.42,0,0,1,281.62,220.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.24,228.25a18.48,18.48,0,0,1,4.89-3.48,34.1,34.1,0,0,1,8.19-2.64,15.78,15.78,0,0,1,3.1-.5,20.84,20.84,0,0,1-3,.88,39,39,0,0,0-7.95,2.9,18.44,18.44,0,0,0-4.62,3.43,12.38,12.38,0,0,0-3.17,5.63,20.54,20.54,0,0,0-.1,7.27,55.38,55.38,0,0,1,.77,8.07,12.11,12.11,0,0,1-2.66,7.78,7.2,7.2,0,0,1-3.37,2.23,7,7,0,0,1-3.89,0,5.21,5.21,0,0,1-3-2.22,6.16,6.16,0,0,1-.85-3.39,8.13,8.13,0,0,1,2.3-5.61,4,4,0,0,1,4.87-.59,2.67,2.67,0,0,1,1.25,1.74,2.54,2.54,0,0,1-2.5,2.88,1.14,1.14,0,0,1-.76-.34c0-.05.27.14.77.14a2.18,2.18,0,0,0,1.75-1.13,2,2,0,0,0,.27-1.45,2.23,2.23,0,0,0-1.08-1.36,3.36,3.36,0,0,0-4.08.64,7.54,7.54,0,0,0-2,5.1,5.37,5.37,0,0,0,.76,2.89,4.34,4.34,0,0,0,2.51,1.79,6,6,0,0,0,6.25-2,11.24,11.24,0,0,0,2.39-7.14,56.19,56.19,0,0,0-.74-7.93",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.53,159.51c-.05,0-.11-.28-.32-.77a3.23,3.23,0,0,0-1.63-1.55A5.4,5.4,0,0,0,184,157a3.91,3.91,0,0,0-3,3.22c-.63,3.47,3.39,7.85,8.17,7a13.23,13.23,0,0,0,6.66-3.21,38.49,38.49,0,0,0,5.44-6.16,36.06,36.06,0,0,1,5.63-6.28,13.59,13.59,0,0,1,7.22-3.31,10.75,10.75,0,0,1,7,1.81,14.74,14.74,0,0,1,4.34,4.49,23.35,23.35,0,0,1,2.95,8.43c.17,1,.26,1.85.31,2.41a2.45,2.45,0,0,1,0,.84,31.13,31.13,0,0,1-.71-3.17,24.59,24.59,0,0,0-3.17-8.12,14.23,14.23,0,0,0-4.19-4.17,10,10,0,0,0-6.41-1.59,12.82,12.82,0,0,0-6.67,3.14,37.11,37.11,0,0,0-5.47,6.14,38.06,38.06,0,0,1-5.6,6.31,14.21,14.21,0,0,1-7.18,3.38,8.06,8.06,0,0,1-6.82-2.21,6.7,6.7,0,0,1-2.18-5.85,4.27,4.27,0,0,1,1.34-2.5,5,5,0,0,1,2.23-1.15,5.62,5.62,0,0,1,3.88.41,3.28,3.28,0,0,1,1.65,1.82A2,2,0,0,1,189.53,159.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.53,166.2a1.2,1.2,0,0,1-.17-.39,3.88,3.88,0,0,0-.52-1.07,7.16,7.16,0,0,0-3.64-2.64,19.34,19.34,0,0,0-7.19-1,17,17,0,0,0-4.47.68,14.54,14.54,0,0,0-4.36,2.53,34.1,34.1,0,0,0-7.72,8.77,18,18,0,0,0-1.41,2.85,8.5,8.5,0,0,1-1.8,3,14,14,0,0,1-6.16,3.7,26.25,26.25,0,0,1-3.61.73,15.78,15.78,0,0,0-3.41,1.16,14.14,14.14,0,0,0-5.63,4.73,12.05,12.05,0,0,0-2.06,7.25,50.56,50.56,0,0,0,1,8.06,25.89,25.89,0,0,1,.37,8.33A12,12,0,0,1,164.8,220c-4,3.64-9.08,5.11-12.61,8.23a12.55,12.55,0,0,0-4,5.4,8.13,8.13,0,0,0,.53,6.11c.86,1.91,2.06,3.6,2.89,5.47a9.15,9.15,0,0,1,.86,5.78,7.7,7.7,0,0,1-3.22,4.22,35,35,0,0,0-3.65,2.76,7.85,7.85,0,0,0-2.23,6.57,24.68,24.68,0,0,0,.89,4.55,11.24,11.24,0,0,1,.4,1.58,1.77,1.77,0,0,1-.18-.37c-.1-.26-.24-.64-.42-1.15A21.49,21.49,0,0,1,143,264.6a10.18,10.18,0,0,1,.18-3.43,7.31,7.31,0,0,1,2-3.57,35.27,35.27,0,0,1,3.66-2.88,7.09,7.09,0,0,0,2.91-3.87,8.46,8.46,0,0,0-.88-5.29c-.8-1.76-2-3.45-2.94-5.44a9,9,0,0,1-.61-6.74,13.38,13.38,0,0,1,4.2-5.83c3.72-3.28,8.78-4.8,12.55-8.26a10.93,10.93,0,0,0,3.58-6.57,25.23,25.23,0,0,0-.37-8,50.53,50.53,0,0,1-1-8.23,13.21,13.21,0,0,1,2.25-7.82,15.27,15.27,0,0,1,6-5,16.58,16.58,0,0,1,3.64-1.22,25.67,25.67,0,0,0,3.53-.69,13.21,13.21,0,0,0,5.78-3.41,7.54,7.54,0,0,0,1.63-2.72,21.16,21.16,0,0,1,1.5-3,34.44,34.44,0,0,1,8-8.9,14.82,14.82,0,0,1,4.6-2.57,17.38,17.38,0,0,1,4.65-.64,19.47,19.47,0,0,1,7.36,1.22,7.16,7.16,0,0,1,3.67,2.91,3.31,3.31,0,0,1,.44,1.15A1.84,1.84,0,0,1,219.53,166.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.32,185.38c1.82-1.27,4.5-.54,6.54.36s3.92,2.22,6.1,2.64a10.6,10.6,0,0,0,6.53-1.08,31.24,31.24,0,0,0,5.58-3.77c.56-.44,1.18-1,1.15-1.71,0-.88-1-1.32-1.85-1.64-8.07-3.16-17.74-.66-24.05,5.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.7,235.27c-.11.1-.31.06-.46-.09s-.18-.35-.08-.45.3-.07.45.08S206.8,235.17,206.7,235.27Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.05,235.61c-.14,0-.23-.34-.2-.72s.17-.69.31-.68.24.33.21.72S212.2,235.62,212.05,235.61Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.11,234.53c-.14,0-.23-.22-.2-.46s.17-.42.31-.4.23.22.2.46S217.25,234.55,217.11,234.53Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,240.68c-.12.08-.36-.08-.54-.34s-.22-.55-.1-.63.36.07.53.34S210.11,240.6,210,240.68Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.42,239.37c-.14,0-.2-.25-.14-.49s.22-.4.36-.37.2.26.14.49S214.56,239.41,214.42,239.37Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.22,235.71c-.14,0-.31-.19-.5-.45s-.33-.5-.25-.62.43,0,.68.32S244.36,235.69,244.22,235.71Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.77,235.71c-.13-.05-.12-.39,0-.74s.38-.6.51-.55.12.39,0,.75S247.91,235.77,247.77,235.71Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.33,236.36c-.14-.05-.15-.34,0-.64s.32-.49.46-.44.14.34,0,.64S251.46,236.41,251.33,236.36Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.21,241.41c-.12.08-.34,0-.48-.23s-.18-.44-.06-.53.33,0,.48.23S245.32,241.32,245.21,241.41Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.74,240.45c-.14,0-.23-.21-.2-.42s.17-.36.31-.34.23.21.2.42S248.89,240.47,248.74,240.45Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.62,237.44c-.14,0-.24-.31-.21-.67s.16-.64.31-.62.24.3.21.66S229.76,237.45,229.62,237.44Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.3,235.29a.25.25,0,0,1-.31-.16.24.24,0,0,1,.2-.27.24.24,0,0,1,.31.15A.25.25,0,0,1,238.3,235.29Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.78,232.16c-.14,0-.3-.13-.36-.37s0-.46.15-.49.3.13.36.37S227.92,232.12,227.78,232.16Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.63,236.57c-.14,0-.23-.24-.2-.51s.16-.47.31-.45.23.24.2.51S221.77,236.59,221.63,236.57Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 227.39,
    cy: 223.39,
    rx: 0.49,
    ry: 0.26,
    transform: "translate(-19.74 424.73) rotate(-83.66)",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.3,369.47c-.43.07-21.11-4.68-21.11-4.68s7.93-4.49,9-5.14c4-2.43,2.46-7.15,2.46-7.15l-12.21,3.92-15.14,11.4L252.71,383.3l-40.65,10.41,4.22,30.46,46-15.37s14.11-2.64,14.84-2.87c1.3-.41,7.12-3.42,10.3-5.08a7.59,7.59,0,0,0,3.79-4.4c1.07-3.42-1.09-4.67-1.09-4.67,5-5.61,1.12-9.47,1.12-9.47,6.09-4.66,2.32-7.48,2.32-7.48s6.79.12,8.75-1.42A3.51,3.51,0,0,0,303.3,369.47Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.71,383.3a2.53,2.53,0,0,1,.22-.28l.67-.81c.62-.72,1.51-1.75,2.64-3.08l9.92-11.43,0,0,15.11-11.44a.15.15,0,0,1,.07,0l12.2-3.94h0a.23.23,0,0,1,.29.15h0a7.4,7.4,0,0,1-.09,4.51,5.88,5.88,0,0,1-1.27,2,8.18,8.18,0,0,1-1.92,1.36L282.32,365l-.07-.48,10.42,2.37,5.38,1.2,2.66.59L302,369l1.23.24.12,0a.21.21,0,0,1,.16.14,3.84,3.84,0,0,1-.4,3.5,3.39,3.39,0,0,1-1.39,1.13,8.55,8.55,0,0,1-1.65.53,32,32,0,0,1-6.57.53l.15-.44a3.49,3.49,0,0,1,1.22,2.15,3.91,3.91,0,0,1-.47,2.36,10.93,10.93,0,0,1-3.08,3.36l0-.36a6,6,0,0,1,1.34,5.23,9.91,9.91,0,0,1-2.47,4.56l-.05-.34a3.36,3.36,0,0,1,1.3,1.8,4.72,4.72,0,0,1,.1,2.14,7.21,7.21,0,0,1-1.74,3.64,9.44,9.44,0,0,1-3.1,2.22L283.59,403c-2.06,1-4,2-5.81,2.8a5.42,5.42,0,0,1-1.43.42l-1.37.27-2.56.49-7.51,1.37-2,.34c-.45.07-.68.09-.68.09s.22-.07.67-.16l2-.4,7.5-1.49,2.55-.51,1.36-.29a5.14,5.14,0,0,0,1.37-.41c1.8-.8,3.72-1.79,5.76-2.84l3.16-1.64a9,9,0,0,0,3-2.16,6.85,6.85,0,0,0,1.63-3.44,4.39,4.39,0,0,0-.1-1.94A3,3,0,0,0,290,392h0a.22.22,0,0,1-.07-.3l0,0a9.69,9.69,0,0,0,2.36-4.36,5.61,5.61,0,0,0-1.24-4.8h0a.24.24,0,0,1,0-.34h0a10.54,10.54,0,0,0,2.93-3.2,3.51,3.51,0,0,0,.41-2.07,3,3,0,0,0-1-1.83h0a.24.24,0,0,1,0-.35.25.25,0,0,1,.19-.09A32,32,0,0,0,300,374a4.33,4.33,0,0,0,2.74-1.46,3.33,3.33,0,0,0,.33-3l.28.16-.42-.05-.33-.06-.66-.14-1.33-.28-2.66-.58-5.39-1.2L282.13,365a.25.25,0,0,1-.06-.47l8.26-4.72a7.64,7.64,0,0,0,1.82-1.29,5.15,5.15,0,0,0,1.16-1.8,7,7,0,0,0,.1-4.19l.3.16-12.22,3.9.07,0L266.39,368l0,0-10,11.32c-1.16,1.3-2.07,2.32-2.71,3-.29.33-.53.59-.71.78S252.72,383.31,252.71,383.3Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.21,382.31a13.17,13.17,0,0,1-5.14.61,6.73,6.73,0,0,1,2.54-.57A6.84,6.84,0,0,1,291.21,382.31Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.73,374.83a23.54,23.54,0,0,1-4-.07,17.79,17.79,0,0,1-4-.43,14.27,14.27,0,0,1,4.05-.09A12.4,12.4,0,0,1,293.73,374.83Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.32,391.67c.06.13-.71.6-1.72,1.05s-1.88.72-1.94.58.72-.6,1.73-1.05S290.26,391.54,290.32,391.67Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.78,408a3.75,3.75,0,1,1-4-3.45A3.74,3.74,0,0,1,243.78,408Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.16,414a3.76,3.76,0,1,1-4-3.44A3.75,3.75,0,0,1,255.16,414Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,400.56a3.75,3.75,0,1,1-4-3.44A3.76,3.76,0,0,1,241,400.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.17,
    cy: 393.41,
    r: 3.75,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.08,385.83a3.75,3.75,0,1,1-4-3.45A3.77,3.77,0,0,1,243.08,385.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.67,414.64a3.75,3.75,0,1,1-4-3.45A3.74,3.74,0,0,1,247.67,414.64Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.4,233.58l-13-22.79A48.14,48.14,0,0,0,426.19,186c0-26.5-21.19-48-47.34-48s-47.34,21.48-47.34,48,21.2,48,47.34,48a46.65,46.65,0,0,0,25.75-7.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.4,233.58l-28.64-7,.21,0a47.63,47.63,0,0,1-24.72,7.42,51.68,51.68,0,0,1-15.32-2.24A47.28,47.28,0,0,1,349,223.77a48,48,0,0,1-18.07-31.92,47.42,47.42,0,0,1,12.31-38.23,49.37,49.37,0,0,1,8.29-7.23c1.55-1,3.08-1.95,4.68-2.79l2.43-1.17,1.22-.59,1.26-.46a48.32,48.32,0,0,1,20.59-3.14,47.71,47.71,0,0,1,42,32.09,49.76,49.76,0,0,1,2.65,15.47,47.57,47.57,0,0,1-6.87,24.81v-.26l12.87,23.23-13.32-23-.07-.12.07-.14a47.1,47.1,0,0,0,6.61-24.54A48.69,48.69,0,0,0,423,170.59a46.91,46.91,0,0,0-41.36-31.43,47.56,47.56,0,0,0-20.19,3.1l-1.24.45-1.19.57-2.38,1.16c-1.57.82-3.06,1.8-4.58,2.73a49.23,49.23,0,0,0-8.13,7.09,47,47,0,0,0,5.57,68.85A46.76,46.76,0,0,0,364.16,231a51.46,51.46,0,0,0,15.08,2.27,47.22,47.22,0,0,0,24.44-7.16l.1-.07.11,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.55,164.78l1.51,23.93a3.9,3.9,0,0,0,3.65,3.63h0a3.89,3.89,0,0,0,4.09-3.45l2.65-24a3.05,3.05,0,0,0-3.07-3.38l-5.83.08A3.05,3.05,0,0,0,374.55,164.78Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.05,205.79a5.84,5.84,0,1,1-3.7-7.38A5.85,5.85,0,0,1,386.05,205.79Z",
    style: {
      fill: "#D175F7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Game--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.06,
    y: 397.65,
    width: 16.64,
    height: 16.64,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.9,
    y: 397.65,
    width: 16.64,
    height: 16.64,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.8,409a2.18,2.18,0,0,1-.56.1c-.36,0-.88.12-1.52.23a25.46,25.46,0,0,0-4.86,1.4,24.85,24.85,0,0,0-4.46,2.38c-.54.36-1,.66-1.26.88a3.13,3.13,0,0,1-.47.33,2.36,2.36,0,0,1,.42-.39c.27-.24.69-.57,1.22-.95a22.5,22.5,0,0,1,4.48-2.44,22,22,0,0,1,4.91-1.36c.65-.09,1.17-.15,1.54-.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.54,412.55s-.31-.11-.81-.22a3.69,3.69,0,0,0-2,.1,4.47,4.47,0,0,0-2.12,1.76,1.7,1.7,0,0,1,.39-.75,3.59,3.59,0,0,1,1.67-1.21,3.52,3.52,0,0,1,2-.05A2.14,2.14,0,0,1,313.54,412.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.84,403.13a1.34,1.34,0,0,1-.43,0,8.41,8.41,0,0,1-1.16,0,11.21,11.21,0,0,1-3.69-1,10,10,0,0,1-3.09-2.28,7.29,7.29,0,0,1-.72-.91c-.15-.23-.23-.37-.21-.37s.36.49,1,1.18a10.8,10.8,0,0,0,3.07,2.19,12,12,0,0,0,3.61,1.08C322.23,403.11,322.84,403.09,322.84,403.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.84,407.89s-.48-.25-1.26-.66a23.54,23.54,0,0,0-3.12-1.34,22.19,22.19,0,0,0-3.3-.84c-.86-.15-1.4-.21-1.4-.24s.14,0,.39,0,.6.05,1,.1a18,18,0,0,1,6.47,2.2c.38.22.68.41.88.55A1.56,1.56,0,0,1,322.84,407.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.86,412.77a2.47,2.47,0,0,1-.42.16,5.39,5.39,0,0,1-1.23.18,6,6,0,0,1-3.84-1.23c-1.31-1-1.79-2.47-2.5-3.19a3.18,3.18,0,0,0-1.35-.92,1.12,1.12,0,0,1,.44.1,3.05,3.05,0,0,1,1,.72c.77.74,1.26,2.18,2.52,3.12a6.16,6.16,0,0,0,3.71,1.26A10,10,0,0,0,322.86,412.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.1,404.09l-.15.13-.44.34c-.39.29-1,.69-1.72,1.14a47,47,0,0,1-6.12,2.92l-6.28,2.56-1.91.75-.52.2-.19.05a.53.53,0,0,1,.17-.09l.51-.23,1.89-.82,6.25-2.61a55,55,0,0,0,6.13-2.86c.75-.43,1.34-.81,1.74-1.07A5.18,5.18,0,0,1,314.1,404.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.56,401.62a7.12,7.12,0,0,1-1.37.95,9.58,9.58,0,0,1-4.34,1.25,7.75,7.75,0,0,1-1.51-.05,2.64,2.64,0,0,1-1.53-.63,1.38,1.38,0,0,1-.33-1.69,2.9,2.9,0,0,1,1.53-1.08,21.83,21.83,0,0,1,8.1-1.39,15.76,15.76,0,0,1,2.18.17,2.52,2.52,0,0,1,1,.4,1.22,1.22,0,0,1,.52,1,2.57,2.57,0,0,1-1,1.8,19.06,19.06,0,0,1-1.51,1.24,21.48,21.48,0,0,1-5.94,3.14,20.68,20.68,0,0,1-4.42,1,13.35,13.35,0,0,1-1.66.12,3.83,3.83,0,0,1,.43-.05c.28,0,.69-.07,1.22-.15a22.18,22.18,0,0,0,4.38-1.07,22.45,22.45,0,0,0,5.88-3.16c.5-.38,1-.79,1.49-1.23a2.45,2.45,0,0,0,.92-1.65c0-.67-.7-1.07-1.37-1.17a16.7,16.7,0,0,0-2.14-.16,21.66,21.66,0,0,0-8,1.36,2.7,2.7,0,0,0-1.44,1,1.21,1.21,0,0,0,.29,1.48,2.49,2.49,0,0,0,1.43.59,9.46,9.46,0,0,0,1.49.07,10,10,0,0,0,4.31-1.18,9.88,9.88,0,0,0,1-.64A3.4,3.4,0,0,1,307.56,401.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.38,
    y: 397.65,
    width: 16.64,
    height: 16.64,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.21,
    y: 397.65,
    width: 16.64,
    height: 16.64,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.47,397.91s-.21,0-.59,0a4,4,0,0,0-1.55.39c-1.27.54-2.56,2-4.47,3a13.58,13.58,0,0,1-5.18,1.51,11.82,11.82,0,0,1-1.64,0,3.65,3.65,0,0,1-.59-.07,3.46,3.46,0,0,1,.6,0,16.16,16.16,0,0,0,1.62-.09,14.3,14.3,0,0,0,5.09-1.56c1.87-.94,3.18-2.42,4.51-2.94a3.71,3.71,0,0,1,1.61-.34A1.79,1.79,0,0,1,364.47,397.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.12,409a2.49,2.49,0,0,1-.56.1c-.36,0-.88.12-1.52.23a25.25,25.25,0,0,0-4.86,1.4,25,25,0,0,0-4.47,2.38c-.54.36-1,.66-1.26.88a3.48,3.48,0,0,1-.46.33,2.49,2.49,0,0,1,.41-.39c.28-.24.7-.57,1.23-.95a22.67,22.67,0,0,1,4.47-2.44,21.94,21.94,0,0,1,4.92-1.36,15.34,15.34,0,0,1,1.53-.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.85,412.55s-.3-.11-.8-.22a3.69,3.69,0,0,0-1.95.1,4.53,4.53,0,0,0-2.13,1.76,1.8,1.8,0,0,1,.4-.75,3.5,3.5,0,0,1,1.66-1.21,3.55,3.55,0,0,1,2.06-.05A2,2,0,0,1,366.85,412.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.15,403.13a1.3,1.3,0,0,1-.42,0,8.5,8.5,0,0,1-1.17,0,11.21,11.21,0,0,1-3.69-1,10.23,10.23,0,0,1-3.09-2.28,7.29,7.29,0,0,1-.72-.91,2.74,2.74,0,0,1-.21-.37s.36.49,1,1.18A10.94,10.94,0,0,0,371,401.9a12.16,12.16,0,0,0,3.62,1.08C375.54,403.11,376.15,403.09,376.15,403.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.15,407.89a13.49,13.49,0,0,1-1.25-.66,23.74,23.74,0,0,0-3.13-1.34,22.19,22.19,0,0,0-3.3-.84c-.86-.15-1.39-.21-1.39-.24s.14,0,.38,0,.6.05,1,.1a18,18,0,0,1,6.47,2.2c.38.22.68.41.88.55A1.29,1.29,0,0,1,376.15,407.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.18,412.77a2.4,2.4,0,0,1-.43.16,5.29,5.29,0,0,1-1.22.18,6,6,0,0,1-3.84-1.23c-1.32-1-1.79-2.47-2.5-3.19a3.24,3.24,0,0,0-1.35-.92,1.15,1.15,0,0,1,.44.1,3,3,0,0,1,1,.72c.77.74,1.27,2.18,2.52,3.12a6.18,6.18,0,0,0,3.71,1.26A10.43,10.43,0,0,0,376.18,412.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.94,
    y: 289.56,
    width: 63.23,
    height: 14.69,
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.16,
    y: 289.56,
    width: 11.37,
    height: 14.69,
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.16,
    y: 289.56,
    width: 11.37,
    height: 14.69,
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.78,289.82l-.34.09-1,.23c-.84.21-2.05.53-3.53,1-2.95.92-6.93,2.58-11.55,3.69a60.93,60.93,0,0,1-12,1.64c-1.55.06-2.81,0-3.68,0l-1-.05a1.44,1.44,0,0,1-.34,0h1.34c.87,0,2.12,0,3.67-.07a63.77,63.77,0,0,0,12-1.7c4.59-1.1,8.57-2.73,11.55-3.62,1.48-.46,2.7-.77,3.55-.95S332.78,289.82,332.78,289.82Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.58,299.79l-.71-.09c-.47-.05-1.16-.13-2.05-.18a27.15,27.15,0,0,0-3.25,0c-.64,0-1.31.1-2,.19a2.3,2.3,0,0,0-1,.32.57.57,0,0,0-.17.89,2.2,2.2,0,0,0,1.07.48l1.24.31c.85.19,1.74.37,2.67.5a34.62,34.62,0,0,0,6,.35c1.05,0,2.13-.12,3.22-.25.55-.07,1.1-.15,1.65-.25a2.58,2.58,0,0,0,1.47-.68,1.19,1.19,0,0,0,0-1.48,2.48,2.48,0,0,0-1.41-.88c-1.14-.29-2.32-.54-3.52-.75-9.64-1.66-18.55-.56-24.86.25-3.17.43-5.72.84-7.49,1.12l-2,.32-.71.1.7-.14,2-.36c1.76-.3,4.31-.74,7.48-1.19,6.31-.84,15.23-2,24.92-.31,1.2.22,2.38.46,3.54.76a2.72,2.72,0,0,1,1.52,1,1.4,1.4,0,0,1,0,1.74,2.73,2.73,0,0,1-1.58.74c-.56.1-1.11.18-1.66.25-1.1.13-2.19.21-3.25.24a34,34,0,0,1-6-.37c-.93-.14-1.82-.32-2.67-.52-.43-.09-.85-.2-1.25-.31a2.28,2.28,0,0,1-1.13-.53.67.67,0,0,1-.18-.61.83.83,0,0,1,.37-.5,2.55,2.55,0,0,1,1.08-.33c.72-.09,1.4-.15,2-.18a26.36,26.36,0,0,1,3.26,0A20.58,20.58,0,0,1,331.58,299.79Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.44,290.33a10,10,0,0,1-2.33,2.14,12.81,12.81,0,0,1-14.47.18,10.34,10.34,0,0,1-2.38-2.09,7,7,0,0,1,.63.57,12.85,12.85,0,0,0,1.83,1.39,13,13,0,0,0,14.31-.17,12.66,12.66,0,0,0,1.8-1.44C360.22,290.54,360.42,290.32,360.44,290.33Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.34,297.84h-.79c-.51,0-1.24,0-2.15,0a27.26,27.26,0,0,0-6.95,1.34,26.56,26.56,0,0,0-6.33,3.14c-.75.51-1.34.95-1.73,1.27l-.47.37c-.1.08-.16.12-.17.11l.15-.14.43-.4a21.11,21.11,0,0,1,1.7-1.33,24.83,24.83,0,0,1,13.36-4.5,18,18,0,0,1,2.17,0l.58,0C361.28,297.82,361.35,297.83,361.34,297.84Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M373.3,293.63s-.13,0-.37,0a7,7,0,0,1-1-.13,11.58,11.58,0,0,1-3.09-1,11.91,11.91,0,0,1-2.67-1.87,9.57,9.57,0,0,1-.68-.72,1.39,1.39,0,0,1-.22-.29s.38.35,1,.9a13,13,0,0,0,5.69,2.87C372.79,293.54,373.3,293.6,373.3,293.63Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.1,298.65a17.7,17.7,0,0,0-1.57-1.18,27.11,27.11,0,0,0-4.28-2,11.17,11.17,0,0,1-3.91-2.74,8.72,8.72,0,0,1-.91-1.14,2.55,2.55,0,0,1-.27-.45s.44.62,1.28,1.49a11.86,11.86,0,0,0,3.89,2.64,24.34,24.34,0,0,1,4.28,2.11,8.23,8.23,0,0,1,1.13.91A2.36,2.36,0,0,1,373.1,298.65Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.23,304.24a10.87,10.87,0,0,0-1-1.38,11.73,11.73,0,0,0-3.17-2.49c-1.38-.8-2.73-1.35-3.61-1.92a8.22,8.22,0,0,1-1-.73,2.28,2.28,0,0,1-.33-.32s.51.4,1.41.92,2.25,1.06,3.64,1.86a11,11,0,0,1,3.18,2.59,5.6,5.6,0,0,1,.68,1.05A1.35,1.35,0,0,1,371.23,304.24Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.84,
    y: 320.79,
    width: 63.23,
    height: 14.69,
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.06,
    y: 320.79,
    width: 11.37,
    height: 14.69,
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.06,
    y: 320.79,
    width: 11.37,
    height: 14.69,
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.68,321.05l-.34.09-1,.23c-.84.21-2.05.53-3.53,1-2.95.92-6.92,2.58-11.54,3.69a61.12,61.12,0,0,1-12,1.64c-1.55.06-2.81,0-3.68,0l-1,0-.35,0h1.35c.86,0,2.12,0,3.66-.07a63.66,63.66,0,0,0,12-1.7c4.6-1.09,8.57-2.73,11.55-3.62,1.48-.46,2.7-.77,3.55-.95S332.68,321.05,332.68,321.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.48,331l-.71-.09c-.47-.05-1.16-.13-2-.18a27.14,27.14,0,0,0-3.25,0c-.63,0-1.31.1-2,.19a2.3,2.3,0,0,0-1,.32.57.57,0,0,0-.16.89,2.16,2.16,0,0,0,1.06.48l1.24.31c.85.19,1.74.37,2.67.5a34.68,34.68,0,0,0,6,.35c1.05,0,2.13-.11,3.23-.25.54-.07,1.1-.15,1.65-.25a2.63,2.63,0,0,0,1.46-.67,1.19,1.19,0,0,0,0-1.49,2.51,2.51,0,0,0-1.42-.88c-1.13-.29-2.32-.54-3.52-.75-9.64-1.66-18.55-.56-24.86.25-3.16.43-5.72.84-7.48,1.12l-2,.32-.71.1.71-.14,2-.36c1.77-.3,4.32-.74,7.48-1.19,6.31-.84,15.23-2,24.92-.31,1.2.22,2.38.46,3.54.76a2.74,2.74,0,0,1,1.53,1,1.4,1.4,0,0,1,0,1.74,2.76,2.76,0,0,1-1.58.74c-.57.1-1.12.18-1.67.25-1.1.13-2.19.21-3.24.24a33.93,33.93,0,0,1-6-.37c-.94-.14-1.83-.32-2.68-.51-.43-.1-.84-.21-1.25-.32a2.32,2.32,0,0,1-1.13-.53.72.72,0,0,1-.18-.61.81.81,0,0,1,.37-.49,2.44,2.44,0,0,1,1.08-.34c.72-.09,1.4-.15,2-.18a28.67,28.67,0,0,1,3.27,0A20.56,20.56,0,0,1,331.48,331Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.34,321.56A10.07,10.07,0,0,1,358,323.7a12.82,12.82,0,0,1-14.48.18,10.12,10.12,0,0,1-2.37-2.09s.22.21.62.57a13.47,13.47,0,0,0,1.83,1.39,13,13,0,0,0,14.31-.17,12.66,12.66,0,0,0,1.8-1.44C360.12,321.77,360.33,321.55,360.34,321.56Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.25,329.07h-.79c-.51,0-1.25,0-2.16,0A26.22,26.22,0,0,0,345,333.58c-.75.51-1.34.95-1.73,1.28-.16.12-.32.24-.46.36l-.17.11s0-.05.14-.14l.44-.4a18,18,0,0,1,1.7-1.33A24.76,24.76,0,0,1,358.3,329a17.85,17.85,0,0,1,2.16,0l.58,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M373.2,324.86s-.13,0-.36,0a6.81,6.81,0,0,1-1-.13,11.31,11.31,0,0,1-5.76-2.9,8.25,8.25,0,0,1-.69-.72,1.39,1.39,0,0,1-.22-.29s.38.35,1,.9a13.8,13.8,0,0,0,2.67,1.79,13,13,0,0,0,3,1.08C372.69,324.77,373.2,324.83,373.2,324.86Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,329.88a17.7,17.7,0,0,0-1.57-1.18,26.68,26.68,0,0,0-4.28-2,11.26,11.26,0,0,1-3.91-2.74,10.32,10.32,0,0,1-.9-1.13,2.55,2.55,0,0,1-.28-.46s.44.62,1.29,1.49a11.81,11.81,0,0,0,3.88,2.64,24,24,0,0,1,4.28,2.11,8.23,8.23,0,0,1,1.13.91A2.25,2.25,0,0,1,373,329.88Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.14,335.47a11.84,11.84,0,0,0-1-1.38A11.73,11.73,0,0,0,367,331.6c-1.37-.8-2.72-1.35-3.61-1.92a8.22,8.22,0,0,1-1-.73,3.27,3.27,0,0,1-.33-.32s.52.4,1.42.92,2.24,1.06,3.63,1.87A11,11,0,0,1,370.3,334a6,6,0,0,1,.67,1.05A1.63,1.63,0,0,1,371.14,335.47Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.43,
    y: 383.01,
    width: 63.23,
    height: 14.69,
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.66,
    y: 383.01,
    width: 11.37,
    height: 14.69,
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.66,
    y: 383.01,
    width: 11.37,
    height: 14.69,
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.27,383.28a1.32,1.32,0,0,1-.33.09l-1,.23c-.84.2-2,.53-3.52,1-3,.92-6.93,2.58-11.55,3.68a59.45,59.45,0,0,1-12,1.64c-1.55.06-2.8,0-3.67,0l-1-.05-.35,0h1.35c.87,0,2.12,0,3.67-.07a64.41,64.41,0,0,0,12-1.7c4.6-1.1,8.58-2.73,11.55-3.62,1.49-.46,2.71-.77,3.56-1A13.14,13.14,0,0,1,329.27,383.28Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.08,393.25l-.72-.09c-.46-.06-1.15-.13-2-.18a29.33,29.33,0,0,0-3.26,0c-.63,0-1.3.1-2,.2a2.26,2.26,0,0,0-1,.32.56.56,0,0,0-.17.89,2.39,2.39,0,0,0,1.07.48c.4.1.81.21,1.24.3.85.2,1.74.37,2.67.5a33.6,33.6,0,0,0,6,.35c1.06,0,2.14-.11,3.23-.25.55-.06,1.1-.15,1.65-.24a2.52,2.52,0,0,0,1.46-.68,1.17,1.17,0,0,0,0-1.48,2.55,2.55,0,0,0-1.41-.89c-1.14-.29-2.33-.53-3.52-.74-9.65-1.66-18.56-.56-24.86.25-3.17.43-5.72.84-7.49,1.12l-2,.32-.71.1s.24-.06.7-.14l2-.36c1.76-.31,4.31-.74,7.48-1.19,6.3-.84,15.23-2,24.91-.31,1.21.21,2.39.46,3.55.76a2.72,2.72,0,0,1,1.52,1,1.38,1.38,0,0,1,0,1.73,2.75,2.75,0,0,1-1.58.75c-.56.09-1.11.18-1.67.24-1.1.14-2.18.22-3.24.25a34.91,34.91,0,0,1-6-.37c-.93-.14-1.83-.32-2.68-.52-.42-.1-.84-.2-1.24-.32a2.26,2.26,0,0,1-1.14-.53.68.68,0,0,1-.17-.61.77.77,0,0,1,.37-.49A2.4,2.4,0,0,1,320,393c.71-.09,1.39-.14,2-.17a26.36,26.36,0,0,1,3.26,0A20.58,20.58,0,0,1,328.08,393.25Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.94,383.78a10.44,10.44,0,0,1-2.33,2.15,12.78,12.78,0,0,1-14.47.17,10.19,10.19,0,0,1-2.38-2.08,6.68,6.68,0,0,1,.63.57,12.85,12.85,0,0,0,1.83,1.39,13,13,0,0,0,14.31-.17,13.88,13.88,0,0,0,1.79-1.44C356.72,384,356.92,383.77,356.94,383.78Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.84,391.29h-.79c-.51,0-1.25,0-2.15,0a26.69,26.69,0,0,0-6.95,1.33,26.17,26.17,0,0,0-6.33,3.15c-.75.51-1.35.95-1.74,1.27l-.46.36c-.1.09-.16.13-.17.12l.14-.15.44-.39a18.82,18.82,0,0,1,1.7-1.34,25,25,0,0,1,6.36-3.21,25.23,25.23,0,0,1,7-1.29,20.21,20.21,0,0,1,2.16,0l.59.05A.55.55,0,0,1,357.84,391.29Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M369.79,387.09a1.67,1.67,0,0,1-.36,0c-.23,0-.57-.06-1-.13a11.54,11.54,0,0,1-3.09-1,11.37,11.37,0,0,1-2.67-1.87,8,8,0,0,1-.68-.71,1.39,1.39,0,0,1-.22-.29s.37.35,1,.89a13.38,13.38,0,0,0,2.66,1.8,13.58,13.58,0,0,0,3,1.07C369.29,387,369.8,387.05,369.79,387.09Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.59,392.11a17,17,0,0,0-1.56-1.19,28.19,28.19,0,0,0-4.29-2,11.2,11.2,0,0,1-3.9-2.73,9.44,9.44,0,0,1-.91-1.14,2.07,2.07,0,0,1-.27-.46s.44.62,1.28,1.49a11.82,11.82,0,0,0,3.88,2.65,24.13,24.13,0,0,1,4.29,2.11,8.9,8.9,0,0,1,1.13.91A2,2,0,0,1,369.59,392.11Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.73,397.7a12.41,12.41,0,0,0-1-1.38,12.17,12.17,0,0,0-3.18-2.5c-1.37-.79-2.72-1.34-3.61-1.92a8.8,8.8,0,0,1-1-.73,1.43,1.43,0,0,1-.33-.32s.51.41,1.41.93,2.25,1.05,3.64,1.86a11.05,11.05,0,0,1,3.18,2.58,6.15,6.15,0,0,1,.67,1A1.6,1.6,0,0,1,367.73,397.7Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.38,
    y: 445.65,
    width: 63.23,
    height: 14.69,
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.61,
    y: 445.65,
    width: 11.37,
    height: 14.69,
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.61,
    y: 445.65,
    width: 11.37,
    height: 14.69,
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.22,445.91a1.55,1.55,0,0,1-.34.09l-1,.23c-.84.2-2.05.53-3.52,1-3,.92-6.93,2.58-11.55,3.69a61,61,0,0,1-12,1.64c-1.55.06-2.81,0-3.67,0l-1-.05-.35,0h1.35c.86,0,2.12,0,3.67-.07a63.68,63.68,0,0,0,12-1.7c4.6-1.1,8.58-2.73,11.55-3.62,1.48-.46,2.7-.77,3.55-1S335.22,445.91,335.22,445.91Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334,455.88l-.71-.09c-.47-.05-1.16-.13-2.05-.18a27.14,27.14,0,0,0-3.25,0c-.63,0-1.31.09-2,.19a2.34,2.34,0,0,0-1,.32.57.57,0,0,0-.16.89,2.16,2.16,0,0,0,1.06.48l1.25.31c.84.19,1.73.37,2.66.5a34.68,34.68,0,0,0,6,.35c1.05,0,2.13-.12,3.23-.25.54-.07,1.1-.15,1.65-.25a2.52,2.52,0,0,0,1.46-.68,1.17,1.17,0,0,0,0-1.48,2.51,2.51,0,0,0-1.42-.88c-1.13-.29-2.32-.54-3.52-.75-9.64-1.66-18.55-.56-24.85.25-3.17.43-5.73.84-7.49,1.12l-2,.32-.71.1.71-.14,2-.36c1.77-.3,4.32-.74,7.49-1.19,6.3-.84,15.22-2,24.91-.31,1.2.22,2.38.46,3.54.76a2.74,2.74,0,0,1,1.53,1,1.4,1.4,0,0,1,0,1.74,2.76,2.76,0,0,1-1.58.74c-.56.09-1.12.18-1.67.25q-1.65.19-3.24.24a34.91,34.91,0,0,1-6-.37c-.94-.14-1.83-.32-2.68-.52-.43-.09-.84-.2-1.25-.31a2.45,2.45,0,0,1-1.13-.53.72.72,0,0,1-.18-.61.87.87,0,0,1,.37-.5,2.6,2.6,0,0,1,1.08-.33q1.08-.14,2-.18a26.39,26.39,0,0,1,3.26,0A20.56,20.56,0,0,1,334,455.88Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.88,446.42a10.07,10.07,0,0,1-2.32,2.14,12.81,12.81,0,0,1-14.47.18,10.07,10.07,0,0,1-2.38-2.09s.22.2.62.57a13.49,13.49,0,0,0,9,3.46,13.26,13.26,0,0,0,7.12-2.24,12.66,12.66,0,0,0,1.8-1.44C362.66,446.63,362.87,446.41,362.88,446.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.79,453.93H363c-.51,0-1.25,0-2.16,0a27.12,27.12,0,0,0-6.94,1.34,26.46,26.46,0,0,0-6.34,3.14c-.75.51-1.34.95-1.73,1.27l-.46.37-.17.11.14-.14.44-.4a21.11,21.11,0,0,1,1.7-1.33,24.38,24.38,0,0,1,6.35-3.22,24.8,24.8,0,0,1,7-1.28,17.85,17.85,0,0,1,2.16,0l.59,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M375.74,449.72s-.13,0-.36,0a6.81,6.81,0,0,1-1-.13,11.31,11.31,0,0,1-5.76-2.9A8.25,8.25,0,0,1,368,446c-.15-.18-.22-.28-.21-.29s.37.35,1,.9a12.88,12.88,0,0,0,5.69,2.87C375.23,449.63,375.74,449.69,375.74,449.72Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.54,454.74a17.7,17.7,0,0,0-1.57-1.18,26.68,26.68,0,0,0-4.28-2,11.26,11.26,0,0,1-3.91-2.74,9.4,9.4,0,0,1-.9-1.14,1.93,1.93,0,0,1-.27-.45s.43.62,1.28,1.49a11.81,11.81,0,0,0,3.88,2.64,23.66,23.66,0,0,1,4.28,2.11,9.14,9.14,0,0,1,1.14.91A2,2,0,0,1,375.54,454.74Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.68,460.33a9.74,9.74,0,0,0-4.13-3.88c-1.37-.79-2.72-1.34-3.61-1.91a9.09,9.09,0,0,1-1-.73,1.84,1.84,0,0,1-.32-.32s.51.4,1.41.92,2.24,1.06,3.64,1.86a11.23,11.23,0,0,1,3.18,2.59,6,6,0,0,1,.67,1.05A1.63,1.63,0,0,1,373.68,460.33Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 352.08,
    width: 63.23,
    height: 14.69,
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.23,
    y: 352.08,
    width: 11.37,
    height: 14.69,
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.23,
    y: 352.08,
    width: 11.37,
    height: 14.69,
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323,366.62l.34-.09,1-.22c.84-.21,2.05-.54,3.52-1,3-.93,6.93-2.59,11.55-3.69a60.37,60.37,0,0,1,12-1.64c1.55-.06,2.81,0,3.68,0l1,.05.35,0h-1.35c-.86,0-2.12,0-3.66.07a63.54,63.54,0,0,0-12,1.69c-4.6,1.1-8.58,2.74-11.55,3.63-1.48.46-2.7.76-3.55.95S323,366.62,323,366.62Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.2,356.66l.71.08c.47.06,1.16.14,2,.19a29.42,29.42,0,0,0,3.25,0c.63,0,1.31-.1,2-.19a2.3,2.3,0,0,0,1-.32.57.57,0,0,0,.16-.89,2.16,2.16,0,0,0-1.06-.48c-.41-.11-.82-.22-1.25-.31-.84-.2-1.73-.37-2.66-.5a33.71,33.71,0,0,0-6-.35c-1.05,0-2.13.11-3.23.25-.54.06-1.1.15-1.65.25a2.57,2.57,0,0,0-1.46.67,1.19,1.19,0,0,0,0,1.49,2.56,2.56,0,0,0,1.42.88c1.13.29,2.32.54,3.52.75,9.64,1.65,18.55.55,24.85-.25,3.17-.43,5.73-.85,7.49-1.12l2-.33c.46-.07.71-.09.71-.09l-.71.14-2,.36c-1.77.3-4.32.73-7.49,1.18-6.3.85-15.22,2-24.91.31-1.2-.21-2.38-.45-3.54-.75a2.8,2.8,0,0,1-1.53-1,1.4,1.4,0,0,1,0-1.74,2.76,2.76,0,0,1,1.58-.74c.57-.1,1.12-.18,1.67-.25q1.65-.19,3.24-.24a33.93,33.93,0,0,1,6,.37c.94.13,1.83.31,2.68.51.43.1.84.21,1.25.32a2.23,2.23,0,0,1,1.13.53.72.72,0,0,1,.18.61.81.81,0,0,1-.37.49,2.48,2.48,0,0,1-1.08.34c-.72.09-1.4.15-2,.18a28.67,28.67,0,0,1-3.27,0A20.56,20.56,0,0,1,324.2,356.66Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.34,366.12a10.07,10.07,0,0,1,2.32-2.14,12.82,12.82,0,0,1,14.48-.18,9.86,9.86,0,0,1,2.37,2.09s-.22-.21-.62-.57a14.25,14.25,0,0,0-1.83-1.4,13.33,13.33,0,0,0-7.19-2.06,13.17,13.17,0,0,0-7.12,2.24,12.73,12.73,0,0,0-1.8,1.43C295.56,365.91,295.35,366.13,295.34,366.12Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.43,358.61h.79c.51,0,1.25,0,2.16,0a26.22,26.22,0,0,0,13.28-4.47c.75-.51,1.34-1,1.73-1.28l.46-.36.17-.12s0,.06-.14.15-.28.26-.44.39a16.32,16.32,0,0,1-1.7,1.34,24.76,24.76,0,0,1-13.36,4.5,17.85,17.85,0,0,1-2.16,0l-.59-.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M368.36,356.15s-.13,0-.36,0a7,7,0,0,1-1-.13,11.47,11.47,0,0,1-3.09-1,11.68,11.68,0,0,1-2.67-1.87,7.86,7.86,0,0,1-.68-.72c-.16-.18-.23-.28-.22-.29s.37.35,1,.9A13.39,13.39,0,0,0,364,354.8a13.68,13.68,0,0,0,3,1.08C367.85,356.06,368.37,356.12,368.36,356.15Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.16,361.17A18.33,18.33,0,0,0,366.6,360a27.27,27.27,0,0,0-4.29-2,11.36,11.36,0,0,1-3.91-2.74,9.4,9.4,0,0,1-.9-1.14,2.55,2.55,0,0,1-.27-.45s.44.62,1.28,1.49a11.81,11.81,0,0,0,3.88,2.64,24.13,24.13,0,0,1,4.29,2.11,9.7,9.7,0,0,1,1.13.91A2,2,0,0,1,368.16,361.17Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.3,366.76a12.41,12.41,0,0,0-.95-1.38,12,12,0,0,0-3.18-2.49c-1.37-.8-2.72-1.35-3.61-1.92a10.16,10.16,0,0,1-1-.73,1.84,1.84,0,0,1-.32-.32s.51.4,1.41.92,2.24,1.06,3.64,1.86a11.23,11.23,0,0,1,3.18,2.59,5.46,5.46,0,0,1,.67,1A1.63,1.63,0,0,1,366.3,366.76Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.89,
    y: 414.26,
    width: 63.23,
    height: 14.69,
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.12,
    y: 414.26,
    width: 11.37,
    height: 14.69,
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.12,
    y: 414.26,
    width: 11.37,
    height: 14.69,
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.89,428.8l.34-.08,1-.23c.84-.21,2.05-.54,3.52-1,3-.92,6.93-2.58,11.55-3.69a61,61,0,0,1,12-1.64c1.55-.06,2.81,0,3.67,0l1,.05.35,0H360c-.86,0-2.12,0-3.67.07a63.55,63.55,0,0,0-12,1.69c-4.6,1.1-8.58,2.74-11.55,3.63-1.49.46-2.71.77-3.55.95S327.89,428.8,327.89,428.8Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.09,418.84l.71.08c.47.06,1.16.14,2.05.19a27.14,27.14,0,0,0,3.25,0c.63,0,1.31-.1,2-.19a2.34,2.34,0,0,0,1-.32.57.57,0,0,0,.16-.89,2.15,2.15,0,0,0-1.07-.48c-.4-.11-.81-.22-1.24-.31-.85-.19-1.73-.37-2.66-.5a33.71,33.71,0,0,0-6-.35c-1.06,0-2.13.11-3.23.25-.54.06-1.1.15-1.65.25a2.51,2.51,0,0,0-1.46.67,1.19,1.19,0,0,0,0,1.49,2.57,2.57,0,0,0,1.41.88c1.14.29,2.33.54,3.53.75,9.64,1.65,18.55.55,24.85-.25,3.17-.43,5.73-.85,7.49-1.12l2-.33c.46-.07.71-.09.71-.09l-.71.14-2,.36c-1.76.3-4.31.73-7.48,1.18-6.3.85-15.23,2-24.91.31-1.21-.21-2.38-.45-3.55-.75a2.75,2.75,0,0,1-1.52-1,1.4,1.4,0,0,1,0-1.74,2.73,2.73,0,0,1,1.58-.74c.56-.1,1.12-.18,1.67-.25q1.65-.19,3.24-.24a33.93,33.93,0,0,1,6,.37c.93.14,1.83.31,2.68.51.43.1.84.21,1.25.32a2.36,2.36,0,0,1,1.13.53.72.72,0,0,1,.18.61.81.81,0,0,1-.37.49,2.48,2.48,0,0,1-1.09.34c-.71.09-1.39.15-2,.18a28.49,28.49,0,0,1-3.26,0A20.22,20.22,0,0,1,329.09,418.84Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.23,428.3a10.07,10.07,0,0,1,2.32-2.14A12.81,12.81,0,0,1,317,426a9.81,9.81,0,0,1,2.38,2.09s-.22-.21-.63-.57a13.57,13.57,0,0,0-1.83-1.4,13,13,0,0,0-14.31.18,14,14,0,0,0-1.79,1.43C300.45,428.09,300.24,428.31,300.23,428.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.32,420.79a.67.67,0,0,1,.21,0h.58c.51,0,1.25,0,2.15,0a26.21,26.21,0,0,0,13.29-4.47c.75-.51,1.34-.95,1.73-1.28l.46-.36.17-.12a.6.6,0,0,1-.14.15l-.44.4a21.11,21.11,0,0,1-1.7,1.33,24.76,24.76,0,0,1-13.36,4.5,17.85,17.85,0,0,1-2.16,0l-.59-.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M373.25,418.33s-.13,0-.36,0a6.81,6.81,0,0,1-1-.13,11.31,11.31,0,0,1-5.76-2.9,8.25,8.25,0,0,1-.69-.72c-.15-.18-.22-.28-.21-.29s.37.36,1,.9a13.39,13.39,0,0,0,2.66,1.79,13.18,13.18,0,0,0,3,1.08C372.74,418.24,373.25,418.3,373.25,418.33Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.05,423.35a17.7,17.7,0,0,0-1.57-1.18,26.68,26.68,0,0,0-4.28-2,11.26,11.26,0,0,1-3.91-2.74,10.32,10.32,0,0,1-.9-1.13,2.8,2.8,0,0,1-.27-.46s.43.62,1.28,1.49a11.81,11.81,0,0,0,3.88,2.64,24.13,24.13,0,0,1,4.29,2.11,9.7,9.7,0,0,1,1.13.91A2.39,2.39,0,0,1,373.05,423.35Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.19,428.94a11.84,11.84,0,0,0-1-1.38,11.73,11.73,0,0,0-3.17-2.49c-1.37-.8-2.72-1.35-3.61-1.92a10.16,10.16,0,0,1-1-.73,1.84,1.84,0,0,1-.32-.32s.51.4,1.41.92,2.24,1.06,3.64,1.87a11.05,11.05,0,0,1,3.18,2.58,5.46,5.46,0,0,1,.67,1A1.63,1.63,0,0,1,371.19,428.94Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.25,
    y: 304.18,
    width: 16.64,
    height: 16.64,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.08,
    y: 304.18,
    width: 16.64,
    height: 16.64,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.34,304.43s-.21,0-.59,0a4,4,0,0,0-1.55.39c-1.27.53-2.56,2-4.47,3a13.25,13.25,0,0,1-6.82,1.55,3.65,3.65,0,0,1-.59-.07,2.52,2.52,0,0,1,.6,0c.38,0,.94,0,1.62-.1a14.26,14.26,0,0,0,5.09-1.55c1.87-.94,3.18-2.42,4.51-2.94a3.71,3.71,0,0,1,1.61-.34A1.67,1.67,0,0,1,363.34,304.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.27,312.44a8.48,8.48,0,0,1-1.25.61,12.82,12.82,0,0,1-3.7.92c-.41,0-.83.06-1.27.06a1.59,1.59,0,0,1-.7-.1.53.53,0,0,1-.21-.71,8.27,8.27,0,0,1,2.29-2,10.92,10.92,0,0,1,6.68-1.61,5.49,5.49,0,0,1,1.79.41,1.57,1.57,0,0,1,1,1.43,2.08,2.08,0,0,1-.93,1.46,13.49,13.49,0,0,1-1.39.89,27.77,27.77,0,0,1-5.18,2.28,33.21,33.21,0,0,1-5.05,1.25l.35-.09,1-.25c.88-.21,2.14-.54,3.66-1.05a28,28,0,0,0,5.12-2.3,15,15,0,0,0,1.36-.88,1.9,1.9,0,0,0,.86-1.31,1.37,1.37,0,0,0-.92-1.24,5,5,0,0,0-1.73-.39,10.79,10.79,0,0,0-6.55,1.56,8.21,8.21,0,0,0-2.24,1.92.34.34,0,0,0,.13.49,1.4,1.4,0,0,0,.62.09,10,10,0,0,0,1.25-.05A13.3,13.3,0,0,0,356,313c.42-.16.73-.3.95-.4A3.26,3.26,0,0,1,357.27,312.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,315.49a2.49,2.49,0,0,1-.56.1c-.36,0-.88.11-1.52.23a24.36,24.36,0,0,0-4.86,1.4,25.69,25.69,0,0,0-4.47,2.37c-.54.37-1,.67-1.26.89a2.78,2.78,0,0,1-.46.32,3.69,3.69,0,0,1,.41-.38c.28-.24.7-.57,1.23-.95A22.17,22.17,0,0,1,358,317a21.94,21.94,0,0,1,4.92-1.36c.64-.09,1.17-.15,1.53-.17A3.52,3.52,0,0,1,365,315.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.72,319.08s-.3-.12-.8-.22a3.69,3.69,0,0,0-1.95.1,4.46,4.46,0,0,0-2.13,1.76,1.8,1.8,0,0,1,.4-.75,3.44,3.44,0,0,1,3.71-1.26A1.72,1.72,0,0,1,365.72,319.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,309.66a1.8,1.8,0,0,1-.42,0,10.49,10.49,0,0,1-1.17,0,11.26,11.26,0,0,1-3.69-1.05,10.06,10.06,0,0,1-3.09-2.27,7.29,7.29,0,0,1-.72-.91,2.17,2.17,0,0,1-.21-.37s.36.49,1,1.18a10.8,10.8,0,0,0,3.07,2.19,12.46,12.46,0,0,0,3.62,1.08C374.41,309.64,375,309.62,375,309.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,314.42s-.48-.26-1.25-.66a23.74,23.74,0,0,0-3.13-1.34,22.19,22.19,0,0,0-3.3-.84c-.86-.15-1.39-.21-1.39-.24s.14,0,.38,0,.6,0,1,.1a18,18,0,0,1,6.47,2.2c.38.22.68.41.88.55A1.29,1.29,0,0,1,375,314.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,319.29s-.14.08-.42.17a5.29,5.29,0,0,1-1.22.18,6,6,0,0,1-3.84-1.23c-1.32-1-1.79-2.47-2.5-3.19a3.17,3.17,0,0,0-1.36-.92,1,1,0,0,1,.45.1,3,3,0,0,1,1,.72c.77.74,1.26,2.18,2.52,3.12a6.23,6.23,0,0,0,3.71,1.26A9.21,9.21,0,0,0,375,319.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.43,
    y: 335.44,
    width: 16.64,
    height: 16.64,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.27,
    y: 335.44,
    width: 16.64,
    height: 16.64,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.88,352s.21,0,.59,0a3.92,3.92,0,0,0,1.55-.39c1.27-.53,2.56-2,4.47-3a13.25,13.25,0,0,1,6.82-1.55c.38,0,.6.06.6.07a2.94,2.94,0,0,1-.6,0,16.19,16.19,0,0,0-1.63.09,14.26,14.26,0,0,0-5.09,1.55c-1.87.94-3.18,2.42-4.51,2.95a3.67,3.67,0,0,1-1.61.33A1.67,1.67,0,0,1,320.88,352Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,344a7.68,7.68,0,0,1,1.26-.62,13.08,13.08,0,0,1,3.69-.92c.41,0,.83-.06,1.27-.06a1.47,1.47,0,0,1,.7.11.52.52,0,0,1,.21.71,8.43,8.43,0,0,1-2.29,2,11,11,0,0,1-6.67,1.6,5.08,5.08,0,0,1-1.8-.41,1.57,1.57,0,0,1-1-1.43,2.09,2.09,0,0,1,.94-1.46,14,14,0,0,1,1.38-.89,27.77,27.77,0,0,1,5.18-2.28,34.8,34.8,0,0,1,5.05-1.25l-.35.1-1,.24c-.87.22-2.13.54-3.66,1.05a27.7,27.7,0,0,0-5.12,2.31,14.92,14.92,0,0,0-1.36.87,1.93,1.93,0,0,0-.86,1.32,1.39,1.39,0,0,0,.93,1.24,5.14,5.14,0,0,0,1.73.38,10.75,10.75,0,0,0,6.55-1.56,8.16,8.16,0,0,0,2.23-1.92.34.34,0,0,0-.13-.49,1.4,1.4,0,0,0-.62-.09c-.43,0-.85,0-1.25.05a14.06,14.06,0,0,0-3.69.84c-.41.16-.73.31-1,.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.23,340.94a3,3,0,0,1,.56-.09c.36,0,.88-.12,1.52-.24a24.36,24.36,0,0,0,4.86-1.4,25,25,0,0,0,4.47-2.37c.54-.36,1-.67,1.26-.89a3.42,3.42,0,0,1,.46-.32,2.23,2.23,0,0,1-.41.38,14.1,14.1,0,0,1-1.23.95,21.91,21.91,0,0,1-9.38,3.8c-.65.1-1.18.15-1.54.17A3.55,3.55,0,0,1,319.23,340.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5,337.35s.3.12.8.23a3.7,3.7,0,0,0,1.95-.11,4.41,4.41,0,0,0,2.13-1.76,1.87,1.87,0,0,1-.4.76,3.49,3.49,0,0,1-1.66,1.2,3.43,3.43,0,0,1-2.05.05A1.8,1.8,0,0,1,318.5,337.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.21,340.92a1.84,1.84,0,0,1-.43,0,10.39,10.39,0,0,1-1.16,0,11.26,11.26,0,0,1-3.69-1.05,9.82,9.82,0,0,1-3.09-2.27,6.45,6.45,0,0,1-.72-.91c-.15-.24-.23-.37-.21-.37s.36.49,1,1.18a10.8,10.8,0,0,0,3.07,2.19,12.32,12.32,0,0,0,3.61,1.08C343.6,340.9,344.21,340.88,344.21,340.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.21,345.68s-.49-.26-1.26-.66a23.17,23.17,0,0,0-3.13-1.34,22.11,22.11,0,0,0-3.29-.84c-.86-.15-1.4-.21-1.4-.24s.14,0,.39,0,.6.05,1,.1a18,18,0,0,1,6.47,2.2c.38.22.68.41.88.55A1.56,1.56,0,0,1,344.21,345.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.23,350.55a1.5,1.5,0,0,1-.42.17,5.39,5.39,0,0,1-1.23.18,6,6,0,0,1-3.84-1.23c-1.32-1-1.79-2.47-2.5-3.19a3.18,3.18,0,0,0-1.35-.92.93.93,0,0,1,.44.1,3.05,3.05,0,0,1,1,.72c.77.74,1.26,2.18,2.52,3.12a6.16,6.16,0,0,0,3.71,1.26A8.2,8.2,0,0,0,344.23,350.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.36,
    y: 428.94,
    width: 16.64,
    height: 16.64,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.2,
    y: 428.94,
    width: 16.64,
    height: 16.64,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.81,445.5s.21,0,.59,0a4,4,0,0,0,1.55-.39c1.27-.53,2.56-2,4.47-3a13.62,13.62,0,0,1,5.18-1.52,11.54,11.54,0,0,1,1.64,0,4.54,4.54,0,0,1,.59.06,2.79,2.79,0,0,1-.6,0,16.16,16.16,0,0,0-1.62.09,14.26,14.26,0,0,0-5.09,1.55c-1.87.94-3.18,2.42-4.51,2.95a3.67,3.67,0,0,1-1.61.33A1.67,1.67,0,0,1,323.81,445.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.88,437.5a7.79,7.79,0,0,1,1.25-.62,13.16,13.16,0,0,1,3.7-.92c.41,0,.83-.06,1.27-.06a1.47,1.47,0,0,1,.7.11.52.52,0,0,1,.21.71,8.43,8.43,0,0,1-2.29,2,11,11,0,0,1-6.68,1.6,5,5,0,0,1-1.79-.41,1.56,1.56,0,0,1-1-1.43,2.08,2.08,0,0,1,.93-1.46,15.41,15.41,0,0,1,1.39-.89,27.77,27.77,0,0,1,5.18-2.28,34.8,34.8,0,0,1,5.05-1.25l-.35.1-1,.24c-.88.22-2.14.54-3.66,1.05a28.07,28.07,0,0,0-5.12,2.31,13.13,13.13,0,0,0-1.36.88,1.92,1.92,0,0,0-.86,1.31,1.37,1.37,0,0,0,.92,1.24,5.25,5.25,0,0,0,1.73.38,10.72,10.72,0,0,0,6.55-1.56,8.21,8.21,0,0,0,2.24-1.92.34.34,0,0,0-.13-.49,1.4,1.4,0,0,0-.62-.09c-.44,0-.86,0-1.25.05a14.06,14.06,0,0,0-3.69.84c-.42.16-.73.31-1,.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.16,434.44a3,3,0,0,1,.56-.09c.36,0,.88-.12,1.52-.23a24.48,24.48,0,0,0,4.86-1.41,25,25,0,0,0,4.47-2.37c.54-.36,1-.67,1.26-.89a2.78,2.78,0,0,1,.46-.32,3.13,3.13,0,0,1-.41.39c-.28.24-.7.56-1.23.94a22.65,22.65,0,0,1-4.47,2.45,21.93,21.93,0,0,1-4.91,1.35c-.65.1-1.18.15-1.54.17A3.52,3.52,0,0,1,322.16,434.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.43,430.85s.3.12.8.23a3.71,3.71,0,0,0,1.95-.11,4.42,4.42,0,0,0,2.13-1.75,1.94,1.94,0,0,1-.4.75,3.49,3.49,0,0,1-1.66,1.2,3.43,3.43,0,0,1-2.05.05A1.72,1.72,0,0,1,321.43,430.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.13,434.42a1.8,1.8,0,0,1-.42,0,8.5,8.5,0,0,1-1.17,0,11.53,11.53,0,0,1-3.69-1,10,10,0,0,1-3.08-2.28,5.78,5.78,0,0,1-.72-.91,3.11,3.11,0,0,1-.22-.37s.37.49,1,1.18a10.94,10.94,0,0,0,3.07,2.19,12.46,12.46,0,0,0,3.62,1.08C346.53,434.4,347.13,434.38,347.13,434.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.13,439.18s-.48-.26-1.25-.66a23.17,23.17,0,0,0-3.13-1.34,22.11,22.11,0,0,0-3.29-.84c-.86-.15-1.4-.21-1.4-.24s.14,0,.38,0,.6.05,1,.1a18,18,0,0,1,6.47,2.2c.38.22.68.41.88.55A1.29,1.29,0,0,1,347.13,439.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.16,444.05a1.49,1.49,0,0,1-.43.17,5.2,5.2,0,0,1-1.22.18,6,6,0,0,1-3.84-1.23c-1.32-1-1.79-2.47-2.5-3.19a3.24,3.24,0,0,0-1.35-.92,1.12,1.12,0,0,1,.44.1,3.05,3.05,0,0,1,1,.72c.77.74,1.26,2.18,2.52,3.12a6.14,6.14,0,0,0,3.71,1.26A8.2,8.2,0,0,0,347.16,444.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.31,
    y: 366.69,
    width: 16.64,
    height: 16.64,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.15,
    y: 366.69,
    width: 16.64,
    height: 16.64,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.76,383.25s.21,0,.59,0a4,4,0,0,0,1.55-.39c1.26-.53,2.56-2,4.47-3a13.2,13.2,0,0,1,6.81-1.55,3.69,3.69,0,0,1,.6.07,2.52,2.52,0,0,1-.6,0c-.38,0-.94,0-1.62.1a14.26,14.26,0,0,0-5.09,1.55c-1.87.94-3.18,2.42-4.51,2.95a3.82,3.82,0,0,1-1.61.33A1.67,1.67,0,0,1,322.76,383.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.83,375.25a7.79,7.79,0,0,1,1.25-.62,13.16,13.16,0,0,1,3.7-.92c.4,0,.83-.06,1.27-.06a1.55,1.55,0,0,1,.69.1.51.51,0,0,1,.21.71,7.85,7.85,0,0,1-2.29,2,10.87,10.87,0,0,1-6.67,1.61,5.13,5.13,0,0,1-1.8-.41,1.55,1.55,0,0,1-1-1.43,2.08,2.08,0,0,1,.93-1.46,15.41,15.41,0,0,1,1.39-.89,28,28,0,0,1,5.17-2.28,33.46,33.46,0,0,1,5.06-1.25l-.35.09-1,.25c-.87.21-2.13.54-3.65,1.05a27.76,27.76,0,0,0-5.13,2.31,15.54,15.54,0,0,0-1.36.87,1.92,1.92,0,0,0-.85,1.32,1.38,1.38,0,0,0,.92,1.24,5.25,5.25,0,0,0,1.73.38,10.74,10.74,0,0,0,6.55-1.56,8.36,8.36,0,0,0,2.24-1.92.34.34,0,0,0-.13-.49,1.4,1.4,0,0,0-.62-.09c-.44,0-.86,0-1.26.05a14.07,14.07,0,0,0-3.68.84c-.42.16-.74.31-.95.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.11,372.19a2.23,2.23,0,0,1,.56-.09c.36,0,.88-.12,1.52-.24a24.55,24.55,0,0,0,4.86-1.4,25.38,25.38,0,0,0,4.47-2.37c.54-.36,1-.67,1.25-.89a3.06,3.06,0,0,1,.47-.32,2.63,2.63,0,0,1-.42.38c-.27.24-.69.57-1.22.95a22.17,22.17,0,0,1-4.47,2.44,21.94,21.94,0,0,1-4.92,1.36c-.64.1-1.17.15-1.53.17A3.52,3.52,0,0,1,321.11,372.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.38,368.6s.3.12.8.23a3.81,3.81,0,0,0,1.95-.11,4.53,4.53,0,0,0,2.13-1.76,1.87,1.87,0,0,1-.4.76,3.56,3.56,0,0,1-1.66,1.2,3.47,3.47,0,0,1-2.06.05A1.72,1.72,0,0,1,320.38,368.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.08,372.17a1.8,1.8,0,0,1-.42,0,10.49,10.49,0,0,1-1.17,0,11.32,11.32,0,0,1-3.69-1.05,10.06,10.06,0,0,1-3.09-2.27,5.75,5.75,0,0,1-.71-.92,1.92,1.92,0,0,1-.22-.37s.36.49,1,1.19a11.15,11.15,0,0,0,3.07,2.19,12.46,12.46,0,0,0,3.62,1.08C345.47,372.15,346.08,372.13,346.08,372.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.08,376.93s-.48-.26-1.25-.66a23.74,23.74,0,0,0-3.13-1.34,22.19,22.19,0,0,0-3.3-.84,12.51,12.51,0,0,1-1.39-.25h.38c.25,0,.6,0,1,.1a18,18,0,0,1,6.47,2.2c.38.22.68.41.88.55S346.09,376.91,346.08,376.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.11,381.8a2,2,0,0,1-.43.17,5.29,5.29,0,0,1-1.22.18,6,6,0,0,1-3.84-1.24c-1.32-1-1.79-2.46-2.5-3.18a3.24,3.24,0,0,0-1.35-.92,1,1,0,0,1,.44.1,3,3,0,0,1,1,.72c.77.74,1.27,2.18,2.53,3.12a6.21,6.21,0,0,0,3.71,1.26A9.21,9.21,0,0,0,346.11,381.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.83,
    y: 304.15,
    width: 16.64,
    height: 16.64,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.66,
    y: 304.15,
    width: 16.64,
    height: 16.64,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.92,304.4s-.21,0-.59,0a3.92,3.92,0,0,0-1.55.39c-1.27.53-2.56,2-4.47,3a13.25,13.25,0,0,1-6.82,1.55l-.6-.07a2.94,2.94,0,0,1,.6,0,16.19,16.19,0,0,0,1.63-.09,14.26,14.26,0,0,0,5.09-1.55c1.87-.94,3.18-2.42,4.51-2.95a3.67,3.67,0,0,1,1.61-.33A1.67,1.67,0,0,1,305.92,304.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.85,312.4a7.79,7.79,0,0,1-1.25.62,13.25,13.25,0,0,1-3.7.92c-.41,0-.83.06-1.27.06a1.47,1.47,0,0,1-.7-.11.52.52,0,0,1-.21-.71,8.43,8.43,0,0,1,2.29-2,11,11,0,0,1,6.67-1.6,5,5,0,0,1,1.8.41,1.57,1.57,0,0,1,1,1.43,2.09,2.09,0,0,1-.94,1.46,14,14,0,0,1-1.38.89A27.77,27.77,0,0,1,297,316a34.8,34.8,0,0,1-5,1.25l.35-.1,1-.24c.87-.22,2.13-.54,3.66-1.05a27.7,27.7,0,0,0,5.12-2.31,14.92,14.92,0,0,0,1.36-.87,1.93,1.93,0,0,0,.86-1.32,1.39,1.39,0,0,0-.93-1.24,5.14,5.14,0,0,0-1.72-.38,10.77,10.77,0,0,0-6.56,1.56,8.16,8.16,0,0,0-2.23,1.92.34.34,0,0,0,.13.49,1.4,1.4,0,0,0,.62.09c.43,0,.85,0,1.25,0a14.06,14.06,0,0,0,3.69-.84c.41-.16.73-.31.95-.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.57,315.46a3,3,0,0,1-.56.09c-.36,0-.88.12-1.52.23a24.48,24.48,0,0,0-4.86,1.41,25,25,0,0,0-4.47,2.37c-.54.36-1,.67-1.26.89a3.42,3.42,0,0,1-.46.32,2.23,2.23,0,0,1,.41-.38,14.1,14.1,0,0,1,1.23-.95,21.91,21.91,0,0,1,9.38-3.8c.65-.1,1.18-.15,1.54-.17A3.55,3.55,0,0,1,307.57,315.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.3,319.05s-.3-.12-.8-.23a3.7,3.7,0,0,0-1.95.11,4.42,4.42,0,0,0-2.13,1.75,1.94,1.94,0,0,1,.4-.75,3.49,3.49,0,0,1,1.66-1.2,3.43,3.43,0,0,1,2-.05A1.8,1.8,0,0,1,308.3,319.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.6,309.63l-.43,0a7.06,7.06,0,0,1-1.16,0,11,11,0,0,1-3.69-1,10.06,10.06,0,0,1-3.09-2.27,6.61,6.61,0,0,1-.72-.92,1.54,1.54,0,0,1-.21-.37s.36.49,1,1.19a10.79,10.79,0,0,0,3.07,2.18,12.13,12.13,0,0,0,3.62,1.09C317,309.6,317.6,309.59,317.6,309.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.6,314.38s-.48-.25-1.26-.65a21.77,21.77,0,0,0-3.12-1.34,23.73,23.73,0,0,0-3.3-.85,13.12,13.12,0,0,1-1.39-.24h.38c.24,0,.6,0,1,.1a17.84,17.84,0,0,1,3.35.79,18.18,18.18,0,0,1,3.13,1.41c.38.22.68.41.88.55A1.48,1.48,0,0,1,317.6,314.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.62,319.26a1.78,1.78,0,0,1-.42.16,5.2,5.2,0,0,1-1.22.19,6,6,0,0,1-3.85-1.24c-1.31-1-1.78-2.46-2.5-3.18a3.18,3.18,0,0,0-1.35-.92,1,1,0,0,1,.45.1,2.89,2.89,0,0,1,1,.72c.77.73,1.26,2.17,2.52,3.12a6.14,6.14,0,0,0,3.71,1.25A8.78,8.78,0,0,0,317.62,319.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.3,
    y: 335.44,
    width: 16.64,
    height: 16.64,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.14,
    y: 335.44,
    width: 16.64,
    height: 16.64,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.4,335.69s-.22,0-.6,0a4,4,0,0,0-1.55.39c-1.26.53-2.56,2-4.47,3A13.2,13.2,0,0,1,350,340.6a3.69,3.69,0,0,1-.6-.07,2.52,2.52,0,0,1,.6,0,14.9,14.9,0,0,0,6.71-1.65c1.88-.94,3.18-2.42,4.51-2.94a3.71,3.71,0,0,1,1.61-.34A1.77,1.77,0,0,1,363.4,335.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,346.75a2.49,2.49,0,0,1-.56.1c-.36,0-.88.11-1.52.23a24.55,24.55,0,0,0-4.86,1.4,26.07,26.07,0,0,0-4.47,2.37c-.54.37-1,.67-1.25.89a3.06,3.06,0,0,1-.47.32,3.4,3.4,0,0,1,.42-.38c.27-.24.69-.57,1.22-.95a22.22,22.22,0,0,1,9.39-3.8c.64-.09,1.17-.15,1.53-.17A3.52,3.52,0,0,1,365,346.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.77,350.34s-.3-.12-.8-.22a3.69,3.69,0,0,0-2,.1,4.53,4.53,0,0,0-2.13,1.76,1.8,1.8,0,0,1,.4-.75A3.45,3.45,0,0,1,365,350,1.76,1.76,0,0,1,365.77,350.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.07,340.92a1.8,1.8,0,0,1-.42,0,10.49,10.49,0,0,1-1.17,0,11.32,11.32,0,0,1-3.69-1.05,9.88,9.88,0,0,1-3.08-2.27,5.78,5.78,0,0,1-.72-.91,3.11,3.11,0,0,1-.22-.37s.36.49,1,1.18a10.94,10.94,0,0,0,3.07,2.19,12.46,12.46,0,0,0,3.62,1.08C374.47,340.9,375.07,340.88,375.07,340.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.07,345.68s-.48-.26-1.25-.66a23.17,23.17,0,0,0-3.13-1.34,22.42,22.42,0,0,0-3.29-.84c-.86-.15-1.4-.21-1.4-.24s.14,0,.38,0,.6.05,1,.1a18,18,0,0,1,6.47,2.2c.38.22.68.41.88.55A1.29,1.29,0,0,1,375.07,345.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.1,350.55a1.49,1.49,0,0,1-.43.17,5.2,5.2,0,0,1-1.22.18,6,6,0,0,1-3.84-1.23c-1.32-1-1.79-2.47-2.5-3.19a3.24,3.24,0,0,0-1.35-.92,1,1,0,0,1,.44.1,3.05,3.05,0,0,1,1,.72c.77.74,1.26,2.18,2.52,3.12a6.14,6.14,0,0,0,3.71,1.26A8.2,8.2,0,0,0,375.1,350.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.83,340.63a2.94,2.94,0,0,1-.65.2l-1.8.48-6,1.5a46.65,46.65,0,0,0-5.86,1.81c-.73.28-1.31.55-1.7.74a5,5,0,0,1-.63.28,4.49,4.49,0,0,1,.59-.35c.39-.21,1-.5,1.68-.81a39.85,39.85,0,0,1,5.87-1.87l6-1.44,1.82-.41A4.55,4.55,0,0,1,365.83,340.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.17,
    y: 428.94,
    width: 16.64,
    height: 16.64,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.01,
    y: 428.94,
    width: 16.64,
    height: 16.64,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.27,429.2s-.21,0-.6,0a4,4,0,0,0-1.55.39c-1.26.54-2.56,2-4.46,3a13.33,13.33,0,0,1-6.82,1.54,3.69,3.69,0,0,1-.6-.07,3.54,3.54,0,0,1,.6,0c.39,0,.94,0,1.63-.09a14.3,14.3,0,0,0,5.09-1.56c1.87-.94,3.18-2.42,4.5-2.94a3.77,3.77,0,0,1,1.62-.34A1.51,1.51,0,0,1,302.27,429.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.92,440.25a2.49,2.49,0,0,1-.56.1c-.37,0-.89.11-1.52.23a24.12,24.12,0,0,0-9.33,3.78c-.54.36-1,.66-1.26.88a2,2,0,0,1-.47.32,3.4,3.4,0,0,1,.42-.38c.27-.24.69-.57,1.22-.95a22.36,22.36,0,0,1,9.39-3.8c.65-.09,1.17-.15,1.54-.16A3.09,3.09,0,0,1,303.92,440.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.65,443.84s-.31-.12-.8-.22a3.69,3.69,0,0,0-2,.1,4.46,4.46,0,0,0-2.13,1.76,1.85,1.85,0,0,1,.39-.75,3.59,3.59,0,0,1,1.67-1.21,3.52,3.52,0,0,1,2.05,0A2,2,0,0,1,304.65,443.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,434.42a1.84,1.84,0,0,1-.43,0,8.41,8.41,0,0,1-1.16,0,11.46,11.46,0,0,1-3.69-1,10.1,10.1,0,0,1-3.09-2.28,7.29,7.29,0,0,1-.72-.91,2.17,2.17,0,0,1-.21-.37s.36.49,1,1.18a10.8,10.8,0,0,0,3.07,2.19,12.29,12.29,0,0,0,3.62,1.08C313.34,434.4,314,434.38,314,434.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,439.18s-.48-.26-1.26-.66a23.54,23.54,0,0,0-3.12-1.34,22.19,22.19,0,0,0-3.3-.84c-.86-.15-1.4-.21-1.4-.24a1.12,1.12,0,0,1,.39,0c.24,0,.6.05,1,.1a18.58,18.58,0,0,1,3.34.79,18.24,18.24,0,0,1,3.13,1.41c.38.22.68.41.89.55A1.66,1.66,0,0,1,314,439.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,444.05s-.14.08-.42.17a5.3,5.3,0,0,1-1.23.18,6,6,0,0,1-3.84-1.23c-1.31-1-1.79-2.47-2.5-3.19a3.18,3.18,0,0,0-1.35-.92,1.12,1.12,0,0,1,.44.1,3.05,3.05,0,0,1,1,.72c.77.74,1.26,2.18,2.52,3.12a6.16,6.16,0,0,0,3.71,1.26A8.2,8.2,0,0,0,314,444.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.71,434.13a3.19,3.19,0,0,1-.66.2l-1.8.48-6,1.5a46.87,46.87,0,0,0-5.87,1.81c-.73.28-1.3.55-1.7.74l-.62.28a3.88,3.88,0,0,1,.58-.35c.39-.21,1-.5,1.69-.81a39.46,39.46,0,0,1,5.87-1.87l6-1.44,1.82-.41A4.28,4.28,0,0,1,304.71,434.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.84,
    y: 335.44,
    width: 16.64,
    height: 16.64,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.68,
    y: 335.44,
    width: 16.64,
    height: 16.64,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.58,346.75a2.81,2.81,0,0,1-.56.09c-.36,0-.88.12-1.52.23a24.58,24.58,0,0,0-9.32,3.78c-.54.36-1,.67-1.26.89a2.57,2.57,0,0,1-.47.32,2.93,2.93,0,0,1,.42-.39c.27-.24.69-.56,1.22-.94a22.47,22.47,0,0,1,4.48-2.45,21.93,21.93,0,0,1,4.91-1.35c.65-.1,1.17-.15,1.54-.17A3.41,3.41,0,0,1,305.58,346.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.32,350.34s-.31-.12-.81-.23a3.71,3.71,0,0,0-1.95.11,4.42,4.42,0,0,0-2.12,1.75,1.81,1.81,0,0,1,.39-.75,3.58,3.58,0,0,1,1.67-1.2,3.43,3.43,0,0,1,2.05,0A1.8,1.8,0,0,1,306.32,350.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.62,340.92l-.43,0a7.06,7.06,0,0,1-1.16,0,11,11,0,0,1-3.69-1,10,10,0,0,1-3.09-2.27,7,7,0,0,1-.72-.92c-.15-.23-.23-.36-.21-.37s.36.49,1,1.19a11,11,0,0,0,3.08,2.18,12.08,12.08,0,0,0,3.61,1.09C315,340.89,315.61,340.88,315.62,340.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.62,345.67a13.85,13.85,0,0,1-1.26-.65,20.86,20.86,0,0,0-3.13-1.34,22.31,22.31,0,0,0-3.29-.85c-.86-.15-1.4-.21-1.4-.24h.39c.24,0,.59,0,1,.1a18,18,0,0,1,6.47,2.2c.38.22.68.41.88.55A1.85,1.85,0,0,1,315.62,345.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.64,350.55a2.47,2.47,0,0,1-.42.16,5.3,5.3,0,0,1-1.23.19,6,6,0,0,1-3.84-1.24c-1.32-1-1.79-2.46-2.5-3.18a3.18,3.18,0,0,0-1.35-.92.93.93,0,0,1,.44.1,2.79,2.79,0,0,1,1,.72c.77.73,1.26,2.17,2.52,3.12a6.12,6.12,0,0,0,3.71,1.25A8.78,8.78,0,0,0,315.64,350.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.88,341.87l-.15.13-.44.35c-.39.29-1,.68-1.72,1.13a46.9,46.9,0,0,1-6.12,2.93L292.17,349l-1.91.76-.52.19-.19.06s.05,0,.17-.1l.51-.23,1.88-.81,6.26-2.61a53.07,53.07,0,0,0,6.13-2.87c.75-.42,1.34-.8,1.74-1.07A5.89,5.89,0,0,1,306.88,341.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.34,339.4a6.83,6.83,0,0,1-1.37,1,9.84,9.84,0,0,1-4.34,1.25,9.69,9.69,0,0,1-1.51-.05,2.71,2.71,0,0,1-1.53-.63,1.38,1.38,0,0,1-.33-1.69,2.76,2.76,0,0,1,1.53-1.08,21.83,21.83,0,0,1,8.1-1.4,15.5,15.5,0,0,1,2.17.17,2.39,2.39,0,0,1,1,.41,1.2,1.2,0,0,1,.52,1,2.61,2.61,0,0,1-1,1.8c-.5.44-1,.85-1.51,1.24a21.75,21.75,0,0,1-5.94,3.14,21.32,21.32,0,0,1-4.42,1,11.91,11.91,0,0,1-1.66.11l.43-.05c.28,0,.69-.07,1.22-.14a22.34,22.34,0,0,0,4.38-1.08,21.87,21.87,0,0,0,5.88-3.16c.5-.38,1-.79,1.49-1.23a2.45,2.45,0,0,0,.92-1.64c0-.68-.71-1.07-1.37-1.18a16.7,16.7,0,0,0-2.14-.16,21.66,21.66,0,0,0-8,1.37,2.65,2.65,0,0,0-1.44,1,1.2,1.2,0,0,0,.29,1.47,2.5,2.5,0,0,0,1.43.6,8.37,8.37,0,0,0,1.49.06,9.92,9.92,0,0,0,4.31-1.17,9.63,9.63,0,0,0,1-.65Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M702.18,460.58c0,.15-146.49.26-327.16.26s-327.2-.11-327.2-.26,146.46-.26,327.2-.26S702.18,460.44,702.18,460.58Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC23);
export default __webpack_public_path__ + "static/media/c23.27b4cb8a3db6e65dccae1581e08318aa.svg";
export { ForwardRef as ReactComponent };